import React, { useRef, useState, useContext, useEffect, useMemo, useCallback } from 'react';
import { VarContext } from '../Context/VarContext';

//import { useCookies } from 'react-cookie';
import Swal from 'sweetalert2'

//import { DownloadTableExcel } from 'react-export-table-to-excel';

import { showToast } from '../Components/Toast';
import toast from 'react-hot-toast'; // Para toast.dismiss()

import { validatePassword, passwordPolicyHint } from '../utils/passwordPolicy';
import PasswordField, { passwordFieldsOk } from '../Components/PasswordField';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCancel, faSortUp, faSortDown, faSort, faPowerOff, faPlus, faSync, faUser, faLock, faLockOpen, faShieldAlt, faSave, faLightbulb, faCog, faEdit, faTrash, faFileExport, faUpload, faFileArrowDown } from '@fortawesome/free-solid-svg-icons'

import * as XLSX from 'xlsx';

import './Admin.css';

import imgFemsaOscuro from '../user/logo_femsa_oscuro.svg';
import imgMircVerde from '../user/logo_mirc.svg';

import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/minimal.css';

import Select from 'react-select';

//import bcrypt from 'bcryptjs';

import { logout } from '../utils/auth';
import { apiCall } from '../utils/api';
import { sortScorms, scormOptionLabel } from '../utils/scormHelpers';
import ScormUpload from '../Components/ScormUpload';
import ScormAssign from '../Components/ScormAssign';
import ScormPreview from '../Components/ScormPreview';

const Admin = () => {

  const GConText = useContext(VarContext);

  // Funciones API para reemplazar DataStore
  const getUsersFromAPI = async () => {
    /* const response = await fetch(`${process.env.REACT_APP_API_BASE}/get-all-users`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    }); */
    const response = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/get-all-users`, {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error('Error obteniendo usuarios');
    }

    const data = await response.json();
    return data;
  };

  const updateUserAPI = async (userId, updates) => {
    const response = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/update-user`, {
      method: 'PUT',
      body: JSON.stringify({ userId, updates })
    });

    if (!response.ok) {
      throw new Error('Error actualizando usuario');
    }

    const data = await response.json();
    return data.user;
  };

  const deleteUserAPI = async (userId) => {
    const response = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/delete-user`, {
      method: 'DELETE',
      body: JSON.stringify({ userId })
    });

    if (!response.ok) {
      throw new Error('Error eliminando usuario');
    }

    return await response.json();
  };

  const createUserAPI = async (userData) => {
    const response = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/create-user`, {
      method: 'POST',
      body: JSON.stringify(userData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error creando usuario');
    }

    return await response.json();
  };

  const handleTokenExpiration = useCallback((response) => {
    if (GConText.logs) console.log('🔍 Verificando token - Status:', response.status);

    if (response.status === 401 || response.status === 403) {
      if (GConText.logs) console.log('🔒 Token expirado detectado - Ejecutando logout');

      showToast.error("⚠️ SESIÓN EXPIRADA - Cerrando sesión automáticamente", {
        duration: 2000
      });

      // Limpiar almacenamiento
      if (GConText.logs) console.log('🧹 Limpiando almacenamiento...');
      sessionStorage.clear();
      localStorage.clear();

      // Limpiar contexto
      if (GConText && GConText.resetAll) {
        GConText.resetAll();
      }

      // ✨ Logout INMEDIATO sin setTimeout
      if (GConText.logs) console.log('🚪 Ejecutando logout inmediato...');
      logout();

      return true; // Indica que el token expiró
    }
    return false; // Token válido
  }, [GConText]);

  // Hacer una función accesible globalmente para testing
  useEffect(() => {
    if (GConText.logs) {
      window.testTokenExpiration = () => {
        if (GConText.logs) console.log('🧪 Probando manejo de token expirado...');
        handleTokenExpiration({ status: 401 });
      };
      return () => {
        delete window.testTokenExpiration;
      };
    }
  }, [GConText.logs, handleTokenExpiration]);

  const debugTokenInfo = useCallback(() => {
    const token = sessionStorage.getItem('accessToken');

    if (!token) {
      if (GConText.logs) console.log('🔒 No hay token disponible');
      return;
    }

    try {
      // Decodificar el JWT (solo la parte del payload)
      const payload = JSON.parse(atob(token.split('.')[1]));

      const now = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
      const exp = payload.exp; // Tiempo de expiración del token
      const iat = payload.iat; // Tiempo de emisión del token

      const timeLeft = exp - now; // Tiempo restante en segundos
      const totalTime = exp - iat; // Tiempo total de vida del token

      if (GConText.logs) console.log('🔐 === DEBUG TOKEN INFO ===');
      if (GConText.logs) console.log('📅 Emitido:', new Date(iat * 1000).toLocaleString());
      if (GConText.logs) console.log('⏰ Expira:', new Date(exp * 1000).toLocaleString());
      if (GConText.logs) console.log('⏳ Tiempo restante:', timeLeft > 0 ? `${Math.floor(timeLeft / 60)}m ${timeLeft % 60}s` : 'EXPIRADO');
      if (GConText.logs) console.log('📊 Progreso:', `${Math.round(((totalTime - timeLeft) / totalTime) * 100)}%`);
      if (GConText.logs) console.log('👤 Usuario:', payload.username || payload.sub || 'N/A');
      if (GConText.logs) console.log('🎭 Rol:', payload.type || payload.role || 'N/A');
      if (GConText.logs) console.log('🔐 === FIN DEBUG TOKEN ===');

      // Advertencia si queda poco tiempo
      if (timeLeft < 300 && timeLeft > 0) { // Menos de 5 minutos
        console.warn('⚠️ TOKEN EXPIRARÁ PRONTO:', `${Math.floor(timeLeft / 60)}m ${timeLeft % 60}s`);
      }

    } catch (error) {
      console.error('❌ Error decodificando token:', error);
    }
  }, [GConText.logs]);

  useEffect(() => {
    if (GConText.logs) {
      // Debug inicial
      debugTokenInfo();

      // Debug cada 5 minutos
      const interval = setInterval(debugTokenInfo, 5 * 60 * 1000);

      return () => clearInterval(interval);
    }
  }, [GConText.logs, debugTokenInfo]);

  // Crear un wrapper para todas las llamadas API:
  //funcion para el manejo de tokens expirado
  const apiCallLegacy = async (url, options = {}) => {
    // ✅ Usar la nueva utilidad API que maneja logout automático
    return apiCall(url, options);
  };

  // Validación de entrada para prevenir XSS
  const validateInput = (input) => {
    return typeof input === 'string'
      ? input.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      : input;
  };

  //const [todos, setTodos] = useState({ notes: [] })
  const [todos, setTodos] = useState([])
  const [originalTodos, setOriginalTodos] = useState([]); // Nuevo estado para el orden original
  const [platformLimits, setPlatformLimits] = useState(null);

  // Versión del backend (GET /admin/version). La del front viene del contexto,
  // inyectada desde client/package.json al compilar.
  const [serverVersion, setServerVersion] = useState(null);
  const [serverInstance, setServerInstance] = useState(null);

  // SCORM preview state
  const [previewScorm, setPreviewScorm] = useState(null);

  // SCORM assigned list (per-user) modal state
  const [scormManageUser, setScormManageUser] = useState(null);
  const [scormSummariesByUser, setScormSummariesByUser] = useState({});
  const [scormSummariesLoading, setScormSummariesLoading] = useState({});

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('users');
  const [availableScorms, setAvailableScorms] = useState([]);
  const [scormSortAdmin, setScormSortAdmin] = useState('alpha');
  const [selectedScormForBulk, setSelectedScormForBulk] = useState('');
  const [selectedScormForManageUser, setSelectedScormForManageUser] = useState('');
  const [assignManageLoading, setAssignManageLoading] = useState(false);
  const [scormModalSearch, setScormModalSearch] = useState('');


  const [sortingEnabled] = useState(true); // Nuevo estado

  const clampPercent = (n) => {
    const num = Number(n);
    if (!Number.isFinite(num)) return null;
    return Math.max(0, Math.min(100, Math.round(num)));
  };

  const getProgressBadgeClass = (percent) => {
    if (percent == null) return 'bg-light text-dark';
    const p = clampPercent(percent);
    if (p == null) return 'bg-light text-dark';
    // Escala solicitada (Admin.css):
    // 0%: #d2d1d1 | 1-24%: #ff6361 | 25-49%: #ff7f36 | 50-74%: #eda200 | 75-99%: #c4c400 | 100%: #80e30f
    if (p >= 100) return 'badge-completado';
    if (p >= 75) return 'badge-en-progreso';
    if (p >= 50) return 'badge-iniciado';
    if (p >= 25) return 'badge-pendiente';
    if (p >= 1) return 'badge-muy-bajo';
    return 'badge-no-iniciado';
  };

  const getAssignedScormIds = (scormAssigned) => {
    const list = Array.isArray(scormAssigned) ? scormAssigned : [];
    const ids = [];
    for (const item of list) {
      if (typeof item === 'string') {
        if (item) ids.push(item);
        continue;
      }
      if (item && typeof item === 'object') {
        const id = item.id || item.scormId || item._id;
        if (id) ids.push(id);
      }
    }
    return ids;
  };

  const isCompletedStatus = (status) => {
    if (status == null) return false;
    if (typeof status === 'boolean') return status;
    const s = String(status).toLowerCase();
    return s === 'completed' || s === 'complete' || s === 'passed' || s === 'success' || s === 'true';
  };

  // Avance global de un usuario, en un solo lugar para que la columna, el
  // filtro, el ordenamiento y la exportación no se contradigan entre sí.
  //
  // Prioridad: el progreso curso por curso (summaries) sobre el statusPercent
  // guardado en el usuario. Ese campo lo escribe el servidor al terminar un
  // curso y puede quedar desactualizado, por eso había usuarios que ya habían
  // terminado y en la lista salían "No iniciado" o "En proceso".
  const getUserProgress = (user, summaries) => {
    const assignedIds = getAssignedScormIds(user && user.scormAssigned);
    const total = assignedIds.length;
    if (!total) return { total: 0, percent: null, completedCount: 0, hasActivity: false };

    if (summaries) {
      const completedCount = assignedIds.filter((id) => isCompletedStatus(summaries[id]?.status)).length;
      const hasActivity = assignedIds.some((id) => {
        const sum = summaries[id];
        if (!sum) return false;
        return (sum.status && sum.status !== 'not attempted') || (sum.score != null && sum.score > 0);
      });
      return { total, percent: clampPercent((completedCount / total) * 100), completedCount, hasActivity };
    }

    if (user && user.status === true) {
      return { total, percent: 100, completedCount: total, hasActivity: true };
    }

    const percent = clampPercent(user && user.statusPercent);
    return {
      total,
      percent,
      completedCount: percent != null ? Math.round((percent / 100) * total) : 0,
      hasActivity: percent != null && percent > 0
    };
  };

  const normalizeAssignedScorms = (scormAssigned) => {
    const list = Array.isArray(scormAssigned) ? scormAssigned : [];
    const apiBase = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');
    return list
      .map((item) => {
        const isString = typeof item === 'string';
        const id = isString ? item : (item && (item.id || ''));
        if (!id) return null;
        const title = isString ? item : (item.title || id);
        const launchPath = isString ? null : (item.launchPath || null);
        const launchUrl = `${apiBase}/scorm/launch/${id}`;
        return { id, title, launchPath, launchUrl };
      })
      .filter(Boolean);
  };

  const closeManageScorm = () => {
    setScormManageUser(null);
    setSelectedScormForManageUser('');
    setAssignManageLoading(false);
    setScormModalSearch('');
  };

  const assignSelectedScormToManageUser = async () => {
    if (!scormManageUser) return;
    if (!selectedScormForManageUser) return showToast.error('Seleccione un SCORM');
    const token = sessionStorage.getItem('accessToken');
    const scormId = selectedScormForManageUser;

    const already = getAssignedScormIds(scormManageUser.scormAssigned).includes(scormId);
    if (already) return showToast.error('Ese SCORM ya está asignado a este usuario');

    let loadingToast;
    try {
      setAssignManageLoading(true);
      loadingToast = showToast.loading('Asignando...');
      const res = await fetch(`${process.env.REACT_APP_API_BASE || ''}/admin/scorm/assign`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ userId: scormManageUser.id, scormId })
      });
      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        throw new Error(errBody.error || 'Error asignando');
      }

      // Update local modal state immediately for better UX
      const picked = (availableScorms || []).find(s => (s.id || s._id) === scormId) || null;
      setScormManageUser((prev) => {
        if (!prev) return prev;
        const prevIds = getAssignedScormIds(prev.scormAssigned);
        if (prevIds.includes(scormId)) return prev;
        const nextAssigned = Array.isArray(prev.scormAssigned) ? [...prev.scormAssigned] : [];
        nextAssigned.push(picked ? { id: picked.id || picked._id, title: picked.title || (picked.id || picked._id) } : { id: scormId, title: scormId });
        return { ...prev, scormAssigned: nextAssigned };
      });

      setSelectedScormForManageUser('');
      showToast.success('SCORM asignado');
      await chkData({ silent: true });
      ensureScormSummariesForUser(scormManageUser.id);
    } catch (err) {
      showToast.error(err.message || 'Error');
    } finally {
      try { if (loadingToast) toast.dismiss(loadingToast); } catch (e) {}
      setAssignManageLoading(false);
    }
  };

  const ensureScormSummariesForUser = async (userId) => {
    if (!userId) return;
    if (scormSummariesByUser && scormSummariesByUser[userId]) return;
    if (scormSummariesLoading && scormSummariesLoading[userId]) return;
    setScormSummariesLoading((prev) => ({ ...prev, [userId]: true }));
    try {
      const token = sessionStorage.getItem('accessToken');
      const res = await fetch(`${process.env.REACT_APP_API_BASE || ''}/scorm/progress/user/${userId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Error obteniendo progreso');
      const body = await res.json();
      const summaries = body.summaries || {};
      setScormSummariesByUser((prev) => ({ ...prev, [userId]: summaries }));
    } catch (e) {
      // Silencioso: la UI seguirá sin pintar status/score
    } finally {
      setScormSummariesLoading((prev) => {
        const copy = { ...prev };
        delete copy[userId];
        return copy;
      });
    }
  };


  const showScormProgressForUser = async (userId, scormId, title) => {
    try {
      const token = sessionStorage.getItem('accessToken');
      const res = await fetch(`${process.env.REACT_APP_API_BASE || ''}/scorm/progress/user/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Error obteniendo progreso');
      }
      const body = await res.json();
      const progress = body.scormProgress || {};
      const summaries = body.summaries || {};
      const sc = progress[scormId] || null;
      const summary = summaries[scormId] || null;
      if (!sc && !summary) {
        Swal.fire('Sin progreso', 'No se encontró progreso para este SCORM en este usuario.', 'info');
        return;
      }
      let html = '<div style="text-align:left; max-height:400px; overflow:auto;">';
      html += `<h4>Progreso: ${title || scormId}</h4>`;
      if (summary) {
        html += '<div style="display:flex; gap:12px; flex-wrap:wrap; margin-bottom:8px;">';
        html += `<div><strong>Score:</strong> ${summary.score != null ? summary.score : '—'}</div>`;
        html += `<div><strong>Status:</strong> ${summary.status != null ? summary.status : '—'}</div>`;
        html += `<div><strong>Última actualización:</strong> ${summary.lastUpdated ? formatearFechaSimple(summary.lastUpdated) : '—'}</div>`;
        html += `<div><strong>Best score:</strong> ${summary.bestScore != null ? summary.bestScore : '—'}</div>`;
        html += '</div><hr/>';
      }
      if (sc) {
        html += '<table class="table table-sm">';
        for (const k of Object.keys(sc)) {
          html += `<tr><td style="font-weight:600">${k}</td><td>${String(sc[k])}</td></tr>`;
        }
        html += '</table>';
      } else {
        html += '<div class="text-muted">No hay detalles crudos disponibles.</div>';
      }
      html += '</div>';
      Swal.fire({ title: 'Progreso SCORM', html, width: 700 });
    } catch (e) {
      Swal.fire('Error', e.message || 'Error', 'error');
    }
  };


  // Nuevo: restaurar el orden original al deshabilitar el orden
  useEffect(() => {
    if (!sortingEnabled) {
      setTodos(originalTodos);
    }
  }, [sortingEnabled, originalTodos]);


  // Agregar esta función en Admin.js, después de exportSelectedUsers:

  function formatearFechaSimple(fechaISO, zona = Intl.DateTimeFormat().resolvedOptions().timeZone) {
    if (!fechaISO) return '';
    const fecha = new Date(fechaISO);
    if (isNaN(fecha.getTime())) return '';

    const opcionesFecha = { day: "numeric", month: "numeric", year: "numeric", timeZone: zona };
    const opcionesHora = { hour: "numeric", minute: "2-digit", hour12: true, timeZone: zona };

    const fechaStr = new Intl.DateTimeFormat("es-MX", opcionesFecha).format(fecha);
    let horaStr = new Intl.DateTimeFormat("es-MX", opcionesHora).format(fecha).toLowerCase();
    // Eliminar puntos en "a.m." / "p.m." → "am" / "pm"
    horaStr = horaStr.replace(" a.m.", "am").replace(" p.m.", "pm");

    return `${fechaStr}/${horaStr}`;
  }


  const [registros, setRegistros] = useState(0)


  //V api
  const chkData = async (opts = {}) => {
    const silent = opts.silent || false;
    const loadingToast = silent ? null : showToast.loading("Cargando usuarios...");
    try {
      const resp = await getUsersFromAPI();
      const users = resp.users || resp;
      if (resp.limits) setPlatformLimits(resp.limits);
      // Agregar propiedades necesarias para la UI
      const data = users.map((option, i) => ({
        ...option,
        id: option.id,
        Ranking: i + 1,
      }));
      setTodos(data);
      setOriginalTodos(data); // ← También agregar esto
      if (GConText.logs) console.log('✅ Usuarios cargados via API:', data.length);
      if (loadingToast) toast.dismiss(loadingToast);

    } catch (error) {
      if (GConText.logs) console.error('❌ Error cargando usuarios:', error);
      if (loadingToast) toast.dismiss(loadingToast);
      // ✨ Si es token expirado, no hacer nada más (ya se maneja en handleTokenExpiration)
      if (!error.message.includes('Token expirado')) {
        showToast.error('Error cargando usuarios');
      }
    }
  };


  // Función para actualizar lista de SCORMs
  const loadAvailableScorms = async () => {
    try {
      const res = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/admin/scorm/list`);
      if (res.ok) {
        const data = await res.json();
        setAvailableScorms(data.scorms || []);
      }
    } catch (e) { /* ignore */ }
  };

  // Grupos admin (entidad propia)
  const [adminGroupsList, setAdminGroupsList] = useState([]);
  const loadAdminGroupsList = async () => {
    try {
      const res = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/admin/groups`);
      if (res.ok) { const d = await res.json(); setAdminGroupsList(d.groups || []); }
    } catch (e) {}
  };

  const loadServerVersion = async () => {
    try {
      const res = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/admin/version`);
      if (!res.ok) return;
      const d = await res.json();
      setServerVersion(d.version || null);
      setServerInstance(d.instancia || null);
    } catch (e) {
      // Silencioso: es informativo, no debe estorbar si falla.
    }
  };

  const markSelfRef = useRef(() => {});

  useEffect(() => {
    chkData();
    loadAvailableScorms();
    loadAdminGroupsList();
    loadServerVersion();
    
    // Flag para ignorar eventos disparados por este mismo componente
    let selfTriggered = false;
    const markSelf = () => { selfTriggered = true; setTimeout(() => { selfTriggered = false; }, 500); };
    // Exponer markSelf para uso interno
    markSelfRef.current = markSelf;

    const onScormChanged = () => {
      if (selfTriggered) return; // Ignorar si fue disparado por nosotros
      try { 
        chkData({ silent: true });
        loadAvailableScorms();
        loadAdminGroupsList();
      } catch(e) { 
        console.error('onScormChanged error', e); 
      }
    };
    const onGroupsChanged = () => {
      loadAdminGroupsList();
    };
    window.addEventListener('scorm:uploaded', onScormChanged);
    window.addEventListener('scorm:changed', onScormChanged);
    window.addEventListener('users:changed', onScormChanged);
    window.addEventListener('groups:changed', onGroupsChanged);
    return () => {
      window.removeEventListener('scorm:uploaded', onScormChanged);
      window.removeEventListener('scorm:changed', onScormChanged);
      window.removeEventListener('users:changed', onScormChanged);
      window.removeEventListener('groups:changed', onGroupsChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* const [edit, setEdit] = useState(false)
  let inputName = useRef();
  let inputPass = useRef();
  let inputUser = useRef();
  let inputGrupo = useRef();
  let selectType = useRef();
  let selectStatus = useRef(); */
  const tableRef = useRef();

  // Reemplazar la función submitDelete existente por esta versión mejorada:
  const submitDelete = (id, username, user) => {
    // Crear el contenido HTML personalizado con FontAwesome
    const htmlContent = `
    <div style="text-align: left; padding: 10px;">
      <p><strong><i class="fas fa-user"></i> Usuario:</strong> ${user.username}</p>
      <p><strong><i class="fas fa-id-card"></i> Nombre:</strong> ${user.nombre}</p>
      <p><strong><i class="fas fa-building"></i> Grupo:</strong> ${user.grupo}</p>
      <p><strong><i class="fas fa-cog"></i> Tipo:</strong> ${user.type === 'admin' ? '<i class="fas fa-user-shield"></i> Administrador' : '<i class="fas fa-user"></i> Usuario'}</p>
      <p><strong><i class="fas fa-chart-line"></i> Estado:</strong> ${user.status ? '<i class="fas fa-check-circle" style="color: green;"></i> Completado' : '<i class="fas fa-times-circle" style="color: red;"></i> No completado'}</p>
      ${user.createdAt ? `<p><strong><i class="fas fa-calendar-alt"></i> Creado:</strong> ${formatearFechaSimple(user.createdAt)}</p>` : ''}
    </div>
  `;

    Swal.fire({
      title: `<i class="fas fa-trash"></i> ¿Eliminar usuario?`,
      html: htmlContent,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: '<i class="fas fa-trash"></i> Sí, eliminar',
      cancelButtonText: '<i class="fas fa-times"></i> Cancelar',
      width: '500px',
      customClass: {
        popup: 'swal-delete-popup',
        title: 'swal-delete-title',
        htmlContainer: 'swal-delete-content'
      },
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const ok = await deleteNote(id);
      if (ok) showToast.success("Usuario eliminado correctamente");
    });
  };


  //V3 - API
  const deleteNote = async (id) => {
    const loading = showToast.loading('Eliminando usuario...');
    try {
      await deleteUserAPI(id);
      setTodos((prev) => (prev || []).filter((item) => item.id !== id));
      setOriginalTodos((prev) => (prev || []).filter((item) => item.id !== id));
      if (GConText.logs) console.log('✅ Usuario eliminado via API');
      /* showToast.success("Usuario eliminado correctamente"); */

      try {
        if (markSelfRef.current) markSelfRef.current();
        window.dispatchEvent(new CustomEvent('users:changed', { detail: { reason: 'delete', userId: id } }));
      } catch (e) {
        try { window.dispatchEvent(new Event('users:changed')); } catch (e2) {}
      }

      return true;
    } catch (error) {
      console.error("❌ Error eliminando usuario:", error);
      showToast.error("No se pudo eliminar el usuario");
      return false;
    } finally {
      try { toast.dismiss(loading); } catch (e) {}
    }
  };

  //------LUIS: FILTRO ---///
  const [sg] = useState("");
  const [su] = useState("");
  const [sn] = useState("");

  //🔍 1. Búsqueda Global - Implementación:
  const [globalSearch, setGlobalSearch] = useState('');

  // Filtros avanzados
  const [filterType, setFilterType] = useState('all'); // all | user | admin
  const [filterStatus, setFilterStatus] = useState('all'); // all | completed | not_completed
  const [filterHasScorm, setFilterHasScorm] = useState('all'); // all | yes | no
  const [filterGroup, setFilterGroup] = useState('all'); // all | <grupo>
  const [filterProgress, setFilterProgress] = useState('all'); // all | no_scorm | no_iniciado | en_proceso | completado
  const [filterCreatedFrom, setFilterCreatedFrom] = useState(''); // YYYY-MM-DD
  const [filterCreatedTo, setFilterCreatedTo] = useState(''); // YYYY-MM-DD

  const groupFilterOptions = useMemo(() => {
    const counts = {};
    for (const u of (todos || [])) {
      const g = u && u.grupo != null ? String(u.grupo).trim() : '';
      if (!g) continue;
      counts[g] = (counts[g] || 0) + 1;
    }
    const groups = Object.keys(counts).sort((a, b) => a.localeCompare(b));
    return { groups, counts };
  }, [todos]);

  const groupSelectOptions = useMemo(() => {
    const opts = [{ value: 'all', label: 'Todos' }];
    const groups = groupFilterOptions.groups || [];
    const counts = groupFilterOptions.counts || {};
    for (const g of groups) {
      const c = counts[g] || 0;
      opts.push({ value: g, label: c ? `${g} (${c})` : g });
    }
    return opts;
  }, [groupFilterOptions]);

  const selectedGroupOption = useMemo(() => {
    return groupSelectOptions.find(o => o.value === filterGroup) || groupSelectOptions[0];
  }, [groupSelectOptions, filterGroup]);

  const groupSelectStyles = useMemo(() => ({
    container: (base) => ({ ...base, width: '100%' }),
    control: (base, state) => ({
      ...base,
      minHeight: 31,
      height: 31,
      borderRadius: 6,
      borderColor: state.isFocused ? '#86b7fe' : base.borderColor,
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13,110,253,.25)' : 'none',
      fontSize: 13
    }),
    valueContainer: (base) => ({ ...base, padding: '0 8px' }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    indicatorsContainer: (base) => ({ ...base, height: 31 }),
    dropdownIndicator: (base) => ({ ...base, padding: 4 }),
    clearIndicator: (base) => ({ ...base, padding: 4 }),
    option: (base, state) => ({
      ...base,
      fontSize: 13,
      paddingTop: 6,
      paddingBottom: 6,
      backgroundColor: state.isSelected ? '#0d6efd' : (state.isFocused ? 'rgba(13,110,253,0.08)' : base.backgroundColor),
      color: state.isSelected ? '#fff' : base.color
    }),
    menuPortal: (base) => ({ ...base, zIndex: 2000 })
  }), []);

  // Ordenamiento (consistente: se aplica sobre lista filtrada)
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' o 'desc'
  // Agregar después de las otras funciones de filtro
  const handleGlobalSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setGlobalSearch(searchTerm);
    setPaginaActual(1); // Resetear a la primera página
  };


  //V2 - Filtros combinados (búsqueda global + filtros específicos)
  const filteredTodos = useMemo(() => {
    let result = todos;

    // Aplicar búsqueda global primero
    if (globalSearch) {
      result = result.filter(user =>
        user.nombre?.toLowerCase().includes(globalSearch.toLowerCase()) ||
        user.username?.toLowerCase().includes(globalSearch.toLowerCase()) ||
        user.grupo?.toLowerCase().includes(globalSearch.toLowerCase()) ||
        user.type?.toLowerCase().includes(globalSearch.toLowerCase()) ||
        user.id?.toLowerCase().includes(globalSearch.toLowerCase()) ||
        (user.status ? 'completado' : 'no completado').includes(globalSearch.toLowerCase())
      );
    }

    // Luego aplicar filtros específicos
    return result.filter(el => {
      // Filtros dinámicos: solo filtra si el campo tiene valor
      if (sn && !el.nombre.toLowerCase().includes(sn)) return false;
      if (su && !el.username.toLowerCase().includes(su)) return false;
      if (sg && !el.grupo.toLowerCase().includes(sg)) return false;

      // type
      if (filterType !== 'all' && (el.type || '').toString().toLowerCase() !== filterType) return false;

      // group
      if (filterGroup !== 'all') {
        const g = el && el.grupo != null ? String(el.grupo).trim() : '';
        if (g !== filterGroup) return false;
      }

      // progress (% avance)
      if (filterProgress !== 'all') {
        const userId = el && el.id ? String(el.id) : null;
        const assignedIds = getAssignedScormIds(el && el.scormAssigned);
        const total = assignedIds.length;

        if (filterProgress === 'no_scorm') {
          if (total !== 0) return false;
        } else {
          if (total === 0) return false;

          const summaries = userId ? (scormSummariesByUser && scormSummariesByUser[userId]) : null;
          const { percent, hasActivity } = getUserProgress(el, summaries);

          // Mismo criterio que el badge de la columna: un usuario con actividad
          // registrada cuenta como "En proceso" aunque no haya completado
          // ningún curso todavía.
          if (filterProgress === 'completado' && (percent == null || percent < 100)) return false;
          if (filterProgress === 'en_proceso' && (percent == null || percent >= 100 || (percent < 1 && !hasActivity))) return false;
          if (filterProgress === 'no_iniciado' && (percent == null || percent !== 0 || hasActivity)) return false;
        }
      }

      // status
      if (filterStatus === 'completed' && !el.status) return false;
      if (filterStatus === 'not_completed' && el.status) return false;

      // scorm assigned
      const hasScorm = Array.isArray(el.scormAssigned) ? el.scormAssigned.length > 0 : false;
      if (filterHasScorm === 'yes' && !hasScorm) return false;
      if (filterHasScorm === 'no' && hasScorm) return false;

      // date range (createdAt)
      const createdAt = el.createdAt ? new Date(el.createdAt) : null;
      if (filterCreatedFrom) {
        const from = new Date(`${filterCreatedFrom}T00:00:00`);
        if (createdAt && createdAt < from) return false;
        if (!createdAt) return false;
      }
      if (filterCreatedTo) {
        const to = new Date(`${filterCreatedTo}T23:59:59`);
        if (createdAt && createdAt > to) return false;
        if (!createdAt) return false;
      }

      return true;
    });
    // getUserProgress es una función pura sin estado: incluirla en las
    // dependencias la invalidaría en cada render y anularía el memo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sg, su, sn, todos, globalSearch, filterType, filterStatus, filterHasScorm, filterGroup, filterProgress, filterCreatedFrom, filterCreatedTo, scormSummariesByUser]); // ← Agregar globalSearch a las dependencias

  const sortedTodos = useMemo(() => {
    const list = [...(filteredTodos || [])];
    if (!sortField) return list;

    const getValue = (u) => {
      const v = u ? u[sortField] : null;
      if (sortField === 'createdAt' || sortField === 'updatedAt') {
        return v ? new Date(v).getTime() : 0;
      }
      if (sortField === 'status') {
        return u && u.status ? 1 : 0;
      }
      if (sortField === 'statusPercent') {
        const userId = u && u.id ? String(u.id) : null;
        const summaries = userId ? (scormSummariesByUser && scormSummariesByUser[userId]) : null;
        const { percent } = getUserProgress(u, summaries);
        return percent != null ? percent : 0;
      }
      return v;
    };

    list.sort((a, b) => {
      const aValue = getValue(a);
      const bValue = getValue(b);

      // strings
      if (typeof aValue === 'string' || typeof bValue === 'string') {
        const as = (aValue || '').toString().toLowerCase();
        const bs = (bValue || '').toString().toLowerCase();
        const cmp = as.localeCompare(bs);
        return sortOrder === 'asc' ? cmp : -cmp;
      }

      // numbers / booleans
      if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    });
    return list;
    // Ver la nota de getUserProgress en filteredTodos.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredTodos, sortField, sortOrder, scormSummariesByUser]);

 // ← Cambiar dependencia de filteredTodos a todos

  //2025may
  const [paginaActual, setPaginaActual] = useState(1);
  const [itemsPorPagina, setItemsPorPagina] = useState(100);

  //const ultimoItemIndex = paginaActual * itemsPorPagina
  //const primerItemIndex = ultimoItemIndex - itemsPorPagina

  const primerItemIndex = (paginaActual - 1) * itemsPorPagina
  const ultimoItemIndex = primerItemIndex + itemsPorPagina

  const itemsEstaPagina = sortedTodos.slice(primerItemIndex, ultimoItemIndex)

  // Auto-cálculo del progreso: usuarios visibles (paginación actual)
  // que tienen SCORM asignados y aún no tienen summaries cargadas.
  const autoProgressUserIds = useMemo(() => {
    return (itemsEstaPagina || [])
      .map((u) => (u && u.id ? String(u.id) : null))
      .filter(Boolean)
      .filter((userId) => {
        const u = (itemsEstaPagina || []).find(x => x && String(x.id) === userId);
        if (!u) return false;
        if (u.status === true) return false;
        const assignedIds = getAssignedScormIds(u.scormAssigned);
        if (!assignedIds.length) return false;
        if (scormSummariesByUser && scormSummariesByUser[userId]) return false;
        if (scormSummariesLoading && scormSummariesLoading[userId]) return false;
        return true;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsEstaPagina, scormSummariesByUser, scormSummariesLoading]);

  const autoProgressUserIdsKey = useMemo(() => (autoProgressUserIds || []).join('|'), [autoProgressUserIds]);

  useEffect(() => {
    if (!autoProgressUserIds || autoProgressUserIds.length === 0) return;
    (async () => {
      const tasks = autoProgressUserIds.map((userId) => ensureScormSummariesForUser(userId));
      await Promise.allSettled(tasks);
    })();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoProgressUserIdsKey]);

  const paginas = []

  const totalpaginas = Math.ceil(sortedTodos.length / itemsPorPagina);

  for (let i = 1; i <= Math.ceil(sortedTodos.length / itemsPorPagina); i++) {
    paginas.push(i);
  }

  useEffect(() => {
    setRegistros(sortedTodos.length);
  }, [sortedTodos]);


  // En el panel de admin
  const [isLoading, setIsLoading] = useState(false);
  const [lastRefresh, setLastRefresh] = useState(Date.now());

  // Importación masiva (Excel)
  const [showBulkImportModal, setShowBulkImportModal] = useState(false);
  const [bulkFileName, setBulkFileName] = useState('');
  const [bulkRows, setBulkRows] = useState([]);
  const [bulkUploading, setBulkUploading] = useState(false);
  const [bulkResult, setBulkResult] = useState(null);
  const [bulkMode, setBulkMode] = useState('create'); // create | update | upsert
  const [bulkUpdatePassword, setBulkUpdatePassword] = useState(false);
  const [bulkChecking, setBulkChecking] = useState(false);
  const [bulkChecked, setBulkChecked] = useState(false);

  const normalizeHeader = (header) => {
    return (header || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  const getRowValue = (row, keys) => {
    for (const key of keys) {
      if (Object.prototype.hasOwnProperty.call(row, key)) return row[key];
    }
    // fallback: intentar buscar por headers normalizados
    const normalizedMap = {};
    Object.keys(row || {}).forEach((k) => {
      normalizedMap[normalizeHeader(k)] = row[k];
    });
    for (const key of keys) {
      const v = normalizedMap[normalizeHeader(key)];
      if (v != null && v !== '') return v;
    }
    return '';
  };

  const validateUsername = (value) => {
    const raw = (value || '').toString();
    const username = raw.trim().toLowerCase();
    const errors = [];
    if (!username) errors.push('username vacío');
    if (/\s/.test(username)) errors.push('username con espacios');
    const deaccented = username.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (deaccented !== username) errors.push('username con acentos');
    if (/[\u0080-\uFFFF]/.test(username)) errors.push('username con caracteres no permitidos');
    return { username, errors };
  };

  const resetBulkImport = () => {
    setBulkFileName('');
    setBulkRows([]);
    setBulkUploading(false);
    setBulkResult(null);
    setBulkMode('create');
    setBulkUpdatePassword(false);
    setBulkChecking(false);
    setBulkChecked(false);
  };

  const closeBulkImportModal = () => {
    setShowBulkImportModal(false);
    resetBulkImport();
  };

  const computeBulkRow = (row, opts) => {
    const errors = [...(row.localErrors || [])];
    const exists = row.exists;
    const password = (row.password || '').toString();

    // La carga masiva sólo da de alta cuentas estándar (type: 'user').
    const checkBulkPassword = () => {
      if (!password) {
        errors.push('contraseña vacía');
        return;
      }
      const pol = validatePassword(password, 'user');
      if (!pol.isValid) {
        if (!pol.meetsLength) errors.push(`contraseña < ${pol.minLength}`);
        if (!pol.meetsTypes) errors.push('contraseña sin 3 de 4 tipos de carácter');
      }
    };

    if (opts.mode === 'create') {
      checkBulkPassword();
      if (exists === true) errors.push('usuario ya existe');
    }

    if (opts.mode === 'update') {
      if (exists == null) errors.push('sin validar contra sistema');
      if (exists === false) errors.push('usuario no existe');
      if (opts.updatePassword) checkBulkPassword();
    }

    if (opts.mode === 'upsert') {
      if (exists == null) errors.push('sin validar contra sistema');
      if (exists === false) checkBulkPassword();
      if (exists === true && opts.updatePassword) checkBulkPassword();
    }

    return {
      ...row,
      errors,
      ok: errors.length === 0
    };
  };

  const recomputeBulkRows = useCallback((rows, nextMode = bulkMode, nextUpdatePassword = bulkUpdatePassword) => {
    const opts = { mode: nextMode, updatePassword: nextUpdatePassword };
    return (rows || []).map((r) => computeBulkRow(r, opts));
  }, [bulkMode, bulkUpdatePassword]);

  const downloadBulkTemplate = () => {
    const wb = XLSX.utils.book_new();

    // Una sola hoja con varios grupos: es el caso normal y el que conviene
    // mostrar. No hace falta un archivo por grupo — la columna "grupo" se lee
    // fila por fila, así que un mismo archivo puede traer todos los grupos.
    const ws = XLSX.utils.json_to_sheet([
      { nombre: 'Juan Pérez', usuario: 'juan.perez@empresa.com', contraseña: 'Temp1234!', grupo: 'ventas' },
      { nombre: 'Ana Gómez', usuario: 'ana.gomez@empresa.com', contraseña: 'Temp1234!', grupo: 'operaciones' },
      { nombre: 'Luis Ramírez', usuario: 'luis.ramirez@empresa.com', contraseña: 'Temp1234!', grupo: 'sistemas' }
    ]);
    XLSX.utils.book_append_sheet(wb, ws, 'usuarios');

    // Hoja de instrucciones. Al importar se omite sola: no tiene encabezados
    // "nombre"/"usuario", que es lo que el lector busca para reconocer datos.
    const wsHelp = XLSX.utils.aoa_to_sheet([
      ['Cómo llenar esta plantilla'],
      [''],
      ['1. Captura los usuarios en la hoja "usuarios", una fila por persona.'],
      ['2. La columna "grupo" puede ser distinta en cada fila. Un mismo archivo'],
      ['   admite todos los grupos que necesites; no hay que separarlos.'],
      ['3. Si un grupo no existe todavía, se crea automáticamente al importar.'],
      ['4. Los grupos también pueden ir en hojas separadas dentro de este mismo'],
      ['   archivo: se leen todas las hojas que tengan los encabezados.'],
      ['5. La contraseña necesita 10 caracteres o más y 3 de los 4 tipos:'],
      ['   mayúscula, minúscula, número y símbolo.'],
      ['6. El usuario es el correo. Sin espacios, sin acentos, en minúsculas.'],
      ['7. En modo "actualizar" la contraseña puede ir vacía.'],
      [''],
      ['Esta hoja es solo informativa: el importador la ignora.']
    ]);
    XLSX.utils.book_append_sheet(wb, wsHelp, 'instrucciones');

    const stamp = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `plantilla_usuarios_${stamp}.xlsx`);
  };

  // Alias aceptados por columna. Se comparan normalizados (sin acentos, minúsculas).
  const BULK_COLUMNS = {
    nombre: ['nombre', 'name', 'nombre completo', 'nombre y apellido'],
    usuario: ['usuario', 'username', 'correo', 'correo electronico', 'email', 'e-mail', 'mail'],
    password: ['contraseña', 'contrasena', 'password', 'clave', 'contraseña temporal'],
    grupo: ['grupo', 'group', 'area', 'departamento', 'equipo']
  };

  // Correos de ejemplo que traen las plantillas (la actual y la anterior, que
  // usaba dos hojas: crear_usuarios y actualizar_usuarios).
  const BULK_EXAMPLE_USERNAMES = new Set([
    'juan.perez@empresa.com',
    'ana.gomez@empresa.com',
    'luis.ramirez@empresa.com'
  ]);

  // Encuentra la fila de encabezados dentro de una hoja.
  //
  // Antes se asumía que los encabezados estaban en la fila 1 y que la lista
  // venía en la primera hoja. Un archivo con una fila de título arriba, o con
  // los grupos separados en varias hojas, hacía que todas las filas salieran
  // inválidas y la importación se rechazara con "No hay filas válidas".
  const findHeaderRow = (matrix) => {
    const wanted = [...BULK_COLUMNS.nombre, ...BULK_COLUMNS.usuario];
    const limit = Math.min(matrix.length, 20); // los encabezados no van más abajo
    for (let i = 0; i < limit; i++) {
      const cells = (matrix[i] || []).map(c => normalizeHeader(c));
      if (cells.some(c => wanted.includes(c))) return i;
    }
    return -1;
  };

  const parseBulkSheet = (sheet, sheetName) => {
    const matrix = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false });
    const headerIdx = findHeaderRow(matrix);
    if (headerIdx === -1) return { rows: [], ignoradas: [], sinEncabezados: true };

    const headers = (matrix[headerIdx] || []).map(h => (h == null ? '' : String(h)));
    const rows = [];
    const ignoradas = [];

    for (let i = headerIdx + 1; i < matrix.length; i++) {
      const cells = matrix[i] || [];
      const row = {};
      headers.forEach((h, col) => { if (h) row[h] = cells[col] != null ? cells[col] : ''; });

      const nombre = validateInput(getRowValue(row, BULK_COLUMNS.nombre)).toString().trim();
      const usuario = validateInput(getRowValue(row, BULK_COLUMNS.usuario)).toString().trim();
      const password = validateInput(getRowValue(row, BULK_COLUMNS.password)).toString();
      const grupo = validateInput(getRowValue(row, BULK_COLUMNS.grupo)).toString().trim();

      // Fila totalmente vacía: se salta sin más.
      if (!nombre && !usuario && !password && !grupo) continue;

      // Fila separadora: solo trae texto en la primera columna, sin correo, sin
      // contraseña y sin grupo. Es el patrón de las bandas tipo "GRUPO VENTAS"
      // que se usan para dividir bloques dentro de una misma hoja. No es un
      // usuario incompleto, así que no se reporta como fila con error, pero
      // tampoco se esconde: se cuenta y se avisa.
      if (nombre && !usuario && !password && !grupo) {
        ignoradas.push({ _row: i + 1, _sheet: sheetName, texto: nombre });
        continue;
      }

      // Filas de ejemplo de la plantilla. Las plantillas traen un renglón de
      // muestra; al leer todas las hojas esas muestras entrarían como usuarios
      // y aparecerían rechazadas sin que nadie las haya capturado.
      if (BULK_EXAMPLE_USERNAMES.has(usuario.toLowerCase())) {
        ignoradas.push({ _row: i + 1, _sheet: sheetName, texto: `${usuario} (fila de ejemplo de la plantilla)` });
        continue;
      }

      const usernameCheck = validateUsername(usuario);
      const localErrors = [...usernameCheck.errors];
      if (!nombre) localErrors.push('nombre vacío');

      rows.push({
        _row: i + 1,           // número de fila real en la hoja (1-indexado)
        _sheet: sheetName,
        nombre,
        username: usernameCheck.username,
        password,
        grupo,
        exists: null,
        localErrors
      });
    }
    return { rows, ignoradas, sinEncabezados: false };
  };

  const onBulkFileSelected = (file) => {
    if (!file) return;
    setBulkResult(null);
    setBulkChecked(false);
    setBulkFileName(file.name || '');
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: 'array' });

        // Se recorren TODAS las hojas: es común separar los grupos en una hoja
        // cada uno. Las hojas sin encabezados reconocibles (índices, portadas,
        // notas) simplemente se omiten.
        const parsedBase = [];
        const hojasUsadas = [];
        const hojasOmitidas = [];
        const filasIgnoradas = [];
        for (const sheetName of wb.SheetNames) {
          const { rows, ignoradas, sinEncabezados } = parseBulkSheet(wb.Sheets[sheetName], sheetName);
          if (sinEncabezados || !rows.length) {
            hojasOmitidas.push(sheetName);
            continue;
          }
          hojasUsadas.push(`${sheetName} (${rows.length})`);
          parsedBase.push(...rows);
          filasIgnoradas.push(...(ignoradas || []));
        }

        if (!parsedBase.length) {
          showToast.error('No se encontraron filas con columnas "nombre" y "usuario". Revisa los encabezados o descarga la plantilla.');
          setBulkRows([]);
          return;
        }

        // Duplicados entre hojas: se marcan aquí para que se vean en la
        // previsualización, no hasta que el servidor los rechace.
        const vistos = new Map();
        parsedBase.forEach((r) => {
          if (!r.username) return;
          if (vistos.has(r.username)) {
            const primero = vistos.get(r.username);
            r.localErrors.push(`duplicado en el archivo (ya aparece en ${primero._sheet} fila ${primero._row})`);
          } else {
            vistos.set(r.username, r);
          }
        });

        setBulkRows(recomputeBulkRows(parsedBase, bulkMode, bulkUpdatePassword));

        const grupos = [...new Set(parsedBase.map(r => r.grupo).filter(Boolean))];
        let msg = `${parsedBase.length} filas leídas de ${hojasUsadas.length} hoja${hojasUsadas.length !== 1 ? 's' : ''}`;
        if (grupos.length > 1) msg += ` · ${grupos.length} grupos: ${grupos.join(', ')}`;
        if (filasIgnoradas.length) msg += ` · ${filasIgnoradas.length} fila${filasIgnoradas.length !== 1 ? 's' : ''} separadora${filasIgnoradas.length !== 1 ? 's' : ''} omitida${filasIgnoradas.length !== 1 ? 's' : ''}`;
        showToast.success(msg);
        if (hojasOmitidas.length) {
          console.warn('Hojas omitidas por no tener encabezados reconocibles:', hojasOmitidas.join(', '));
        }
        if (filasIgnoradas.length) {
          console.warn('Filas omitidas por parecer separadoras:', filasIgnoradas.map(f => `${f._sheet}:${f._row} "${f.texto}"`).join(' | '));
        }
      } catch (err) {
        console.error('Error parseando Excel:', err);
        showToast.error('No se pudo leer el Excel. Verifica el formato.');
        setBulkRows([]);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const validateBulkAgainstSystem = async () => {
    if (!bulkRows.length) return showToast.error('Carga un archivo primero');
    const usernames = (bulkRows || []).map(r => r.username).filter(Boolean);
    if (!usernames.length) return showToast.error('No hay usernames para validar');

    setBulkChecking(true);
    const loading = showToast.loading('Validando contra el sistema...');
    try {
      const res = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/admin/users/check-usernames`, {
        method: 'POST',
        body: JSON.stringify({ usernames })
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.error || 'Error validando');

      const map = new Map();
      (body.results || []).forEach((it) => {
        map.set(it.username, { exists: it.exists === true, userId: it.userId || null });
      });

      const next = (bulkRows || []).map((r) => {
        const entry = map.get(r.username);
        return {
          ...r,
          exists: entry ? entry.exists : null,
          userId: entry ? entry.userId : null
        };
      });

      setBulkRows(recomputeBulkRows(next, bulkMode, bulkUpdatePassword));
      setBulkChecked(true);
      showToast.success('Validación lista');
    } catch (e) {
      console.error(e);
      showToast.error(e.message || 'Error validando');
    } finally {
      toast.dismiss(loading);
      setBulkChecking(false);
    }
  };

  const downloadBulkReport = () => {
    try {
      const rows = bulkRows || [];
      const baseSheet = rows.map(r => ({
        hoja: r._sheet || '',
        fila: r._row,
        nombre: r.nombre,
        username: r.username,
        grupo: r.grupo,
        existeEnSistema: r.exists == null ? '' : (r.exists ? 'sí' : 'no'),
        ok: r.ok ? 'sí' : 'no',
        errores: (r.errors || []).join(', ')
      }));

      const invalidSheet = rows.filter(r => !r.ok).map(r => ({
        hoja: r._sheet || '',
        fila: r._row,
        nombre: r.nombre,
        username: r.username,
        grupo: r.grupo,
        existeEnSistema: r.exists == null ? '' : (r.exists ? 'sí' : 'no'),
        errores: (r.errors || []).join(', ')
      }));

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(baseSheet), 'previsualizacion');
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(invalidSheet), 'no_suben');

      if (bulkResult) {
        if (Array.isArray(bulkResult.created)) {
          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(bulkResult.created), 'creados');
        }
        if (Array.isArray(bulkResult.updated)) {
          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(bulkResult.updated), 'actualizados');
        }
        if (Array.isArray(bulkResult.skipped)) {
          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(bulkResult.skipped), 'skipped');
        }
        if (Array.isArray(bulkResult.failed)) {
          XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(bulkResult.failed), 'failed');
        }
      }

      const stamp = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `reporte_import_usuarios_${stamp}.xlsx`);
    } catch (e) {
      console.error(e);
      showToast.error('No se pudo generar el reporte');
    }
  };

  const uploadBulkUsers = async () => {
    const valid = (bulkRows || []).filter(r => r.ok);
    const invalid = (bulkRows || []).filter(r => !r.ok);
    if (!bulkRows.length) return showToast.error('Carga un archivo primero');

    if ((bulkMode === 'update' || bulkMode === 'upsert') && !bulkChecked) {
      return showToast.error('Primero valida contra el sistema');
    }

    if (!valid.length) {
      // Un "no hay filas válidas" a secas obliga a revisar fila por fila para
      // entender qué pasó, y es fácil atribuirlo a la causa equivocada. Se
      // agrupan los motivos y se muestran los más frecuentes.
      const conteo = {};
      invalid.forEach(r => (r.errors || []).forEach(e => { conteo[e] = (conteo[e] || 0) + 1; }));
      const top = Object.entries(conteo).sort((a, b) => b[1] - a[1]);

      const listaHtml = top.slice(0, 6)
        .map(([motivo, n]) => `<li><b>${n}</b> ${n === 1 ? 'fila' : 'filas'}: ${motivo}</li>`)
        .join('');

      const soloPassword = top.length > 0 && top.every(([m]) => m.startsWith('contraseña'));

      await Swal.fire({
        title: 'Ninguna fila se puede importar',
        icon: 'warning',
        width: 620,
        html:
          `<div style="text-align:left">
            <p>Se leyeron <b>${bulkRows.length}</b> filas y las <b>${invalid.length}</b> quedaron rechazadas por:</p>
            <ul style="margin:8px 0 0 18px;padding:0">${listaHtml}</ul>
            ${top.length > 6 ? `<p style="color:#64748b;font-size:13px;margin-top:6px">y ${top.length - 6} motivo(s) más</p>` : ''}
            ${soloPassword ? `<div style="background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:10px 14px;margin-top:12px">
              <strong>Es solo la contraseña.</strong> Los nombres, correos y grupos están bien.
              Corrige la columna <b>contraseña</b> en el Excel y vuelve a subirlo:
              <br/><span style="font-size:13px">${passwordPolicyHint('user')}</span>
            </div>` : ''}
            <p style="color:#64748b;font-size:13px;margin-top:12px">
              El detalle fila por fila está en la tabla de abajo y en "Descargar reporte".
            </p>
          </div>`,
        confirmButtonText: 'Entendido'
      });
      return;
    }

    // Detectar grupos nuevos que se van a crear
    const existingGroupNames = new Set(adminGroupsList.map(g => g.name.toLowerCase()));
    const newGroupsInImport = [...new Set(valid.map(r => r.grupo).filter(g => g && !existingGroupNames.has(g.toLowerCase())))];

    let confirmHtml = `Modo: <b>${bulkMode}</b><br/>Filas válidas a procesar: <b>${valid.length}</b>`;
    if (newGroupsInImport.length > 0) {
      confirmHtml += `<br/><br/><div style="background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:10px 14px;text-align:left;margin-top:8px;">
        <strong>⚠️ Se crearán ${newGroupsInImport.length} grupo${newGroupsInImport.length > 1 ? 's' : ''} nuevo${newGroupsInImport.length > 1 ? 's' : ''}:</strong>
        <ul style="margin:6px 0 0 16px;padding:0;">${newGroupsInImport.map(g => `<li>${g}</li>`).join('')}</ul>
      </div>`;
    }

    const confirm = await Swal.fire({
      title: 'Confirmar importación',
      html: confirmHtml,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    });
    if (!confirm.isConfirmed) return;

    setBulkUploading(true);
    const loading = showToast.loading('Importando usuarios...');
    try {
      const res = await apiCallLegacy(`${process.env.REACT_APP_API_BASE}/admin/import-users`, {
        method: 'POST',
        body: JSON.stringify({
          mode: bulkMode,
          updatePassword: bulkUpdatePassword,
          users: valid.map(u => ({
            nombre: u.nombre,
            username: u.username,
            ...(bulkUpdatePassword || bulkMode === 'create' || (bulkMode === 'upsert' && u.exists === false) ? { password: u.password } : {}),
            grupo: u.grupo
          }))
        })
      });

      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.error || 'Error importando');

      setBulkResult(body);
      const summary = body.summary || {};
      showToast.success(`Importación lista. Creados: ${summary.created || 0} | Actualizados: ${summary.updated || 0} | Duplicados: ${summary.skipped || 0} | Fallidos: ${summary.failed || 0}`);
      // Notificar grupos nuevos creados
      if (body.newGroups && body.newGroups.length > 0) {
        showToast.success(`Grupos creados: ${body.newGroups.join(', ')}`);
      }
      await chkData({ silent: true });
      await loadAdminGroupsList();
      try {
        if (markSelfRef.current) markSelfRef.current();
        window.dispatchEvent(new Event('users:changed'));
      } catch (e) {
        // ignore
      }
    } catch (e) {
      console.error(e);
      const isLimit = e.message && e.message.toLowerCase().includes('límite');
      if (isLimit) {
        Swal.fire({ title: 'Límite alcanzado', text: e.message, icon: 'warning' });
      } else {
        showToast.error(e.message || 'Error importando');
      }
    } finally {
      toast.dismiss(loading);
      setBulkUploading(false);
    }
  };

  const exportUsersToExcel = async (mode) => {
    try {
      const rows = mode === 'all' ? (todos || []) : (filteredTodos || []);
      if (!rows.length) { showToast.error('No hay usuarios para exportar'); return; }

      showToast.info('Generando exportación con progreso...');

      const token = sessionStorage.getItem('accessToken');
      const apiBase = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

      // Obtener lista de cursos para títulos
      const scormMap = {};
      (availableScorms || []).forEach((s) => { scormMap[s.id || s._id] = s.title || s.id || s._id; });

      // Obtener progreso de cada usuario
      const progressByUser = {};
      const batchSize = 10;
      for (let i = 0; i < rows.length; i += batchSize) {
        const batch = rows.slice(i, i + batchSize);
        const results = await Promise.allSettled(
          batch.map((u) =>
            fetch(`${apiBase}/scorm/progress/user/${u.id}`, {
              headers: { 'Authorization': `Bearer ${token}` }
            }).then((r) => r.ok ? r.json() : null)
          )
        );
        results.forEach((r, idx) => {
          const u = batch[idx];
          if (r.status === 'fulfilled' && r.value) {
            progressByUser[u.id] = r.value.summaries || {};
          }
        });
      }

      // Recolectar todos los scormIds asignados
      const allScormIds = [...new Set(rows.flatMap((u) => {
        const assigned = Array.isArray(u.scormAssigned) ? u.scormAssigned : [];
        return assigned.map((item) => typeof item === 'string' ? item : (item && (item.id || '')));
      }).filter(Boolean))];

      // Construir dataset
      const dataset = rows.map((u) => {
        // Mismo criterio que la columna "Avance global" de la tabla: el progreso
        // real por curso manda sobre el statusPercent guardado.
        const { percent, completedCount, total, hasActivity } = getUserProgress(u, progressByUser[u.id] || null);
        let avanceGlobal = '';
        if (total > 0 && percent != null) {
          if (percent >= 100) avanceGlobal = 'Completado';
          else if (percent >= 1 || hasActivity) avanceGlobal = 'En proceso';
          else avanceGlobal = 'No iniciado';
        }

        const base = {
          id: u.id || '',
          nombre: u.nombre || '',
          username: u.username || '',
          grupo: u.grupo || '',
          avance_global: avanceGlobal,
          cursos_completados: total > 0 ? `${completedCount}/${total}` : '',
        };

        // Agregar columnas por cada curso
        const summaries = progressByUser[u.id] || {};
        allScormIds.forEach((scormId) => {
          const title = scormMap[scormId] || scormId;
          const s = summaries[scormId];
          // Mismas etiquetas que la tabla de cursos del usuario en la plataforma
          let statusLabel = '—';
          if (s && s.status) {
            const raw = String(s.status).toLowerCase();
            if (isCompletedStatus(raw)) statusLabel = 'Completado';
            else if (raw === 'failed') statusLabel = 'Reprobado';
            else if (raw === 'not attempted') statusLabel = 'No iniciado';
            else statusLabel = 'En proceso';
          }
          base[`${title} - Status`] = statusLabel;
          base[`${title} - Score`] = s && s.score != null ? s.score : '—';
        });

        return base;
      });

      const ws = XLSX.utils.json_to_sheet(dataset);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'usuarios');
      const stamp = new Date().toISOString().slice(0, 10);
      const name = mode === 'all' ? `usuarios_todos_${stamp}.xlsx` : `usuarios_filtrados_${stamp}.xlsx`;
      XLSX.writeFile(wb, name);
      showToast.success('Exportación completada');
    } catch (e) {
      console.error(e);
      showToast.error('No se pudo exportar');
    }
  };

  //V3 - API
  const refreshData = async () => {
    if (GConText.logs) console.log("🚀 ~ refreshData (API):");
    try {
      setIsLoading(true);
      // Recargar datos via API
      await chkData();
      setLastRefresh(Date.now());
      if (GConText.logs) console.log('✅ Datos actualizados via API');

    } catch (error) {
      if (GConText.logs) console.error('Error refrescando datos:', error);
      // ✨ Si el error es por token expirado, no mostrar toast adicional
      if (!error.message.includes('Token expirado')) {
        showToast.error('Error actualizando datos');
      }
    } finally {
      setIsLoading(false);
    }
  };


  // Auto-refresh cada 30 segundos
  /* useEffect(() => {
    const interval = setInterval(refreshData, 30000);
    return () => clearInterval(interval);
  }, []); */

  //1. Agregar estados para el popup:
  // Estados para el popup de edición
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  // Por esto:
  const [editUsername, setEditUsername] = useState('');
  const [editNombre, setEditNombre] = useState('');
  const [editPassword, setEditPassword] = useState('');
  const [editPasswordConfirm, setEditPasswordConfirm] = useState('');
  const [editType, setEditType] = useState('user');
  const [editStatus, setEditStatus] = useState(false);
  const [, setSelectedStatus] = useState('');
  const [editGroup, setEditGroup] = useState('');
  const [editRequire2FA, setEditRequire2FA] = useState(false);
  //2. Funciones para manejar el popup:

  // Abrir popup de edición
  const openEditModal = (user) => {
    setEditingUser(user);
    setEditUsername(user.username);
    setEditNombre(user.nombre);
    setEditPassword(''); // Campo vacío para nueva contraseña
    setEditPasswordConfirm('');
    setEditType(user.type);
    setEditStatus(user.status);
    setEditStatus(user.status);
    setEditGroup(user.grupo);
    setEditRequire2FA(user.require2FA || false);
    setShowEditModal(true);
  };

  // Cerrar popup
  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingUser(null);
    setEditUsername('');
    setEditNombre('');
    setEditPassword('');
    setEditPasswordConfirm('');
    setEditType('user');
    setEditStatus(false);
    setEditGroup('');
    setSelectedStatus(''); // ← Limpiar
  };

  // Guardar cambios
  const saveUserChanges = async () => {
    try {
      const notifyUsersChanged = (detail) => {
        try {
          if (typeof window.CustomEvent === 'function') {
            window.dispatchEvent(new CustomEvent('users:changed', { detail }));
          } else {
            window.dispatchEvent(new Event('users:changed'));
          }
        } catch (e) {}
      };

      const updates = {};

      // Solo incluir campos que realmente cambiaron
      if (editUsername !== editingUser.username) updates.username = editUsername;
      if (editNombre !== editingUser.nombre) updates.nombre = editNombre;
      if (editType !== editingUser.type) updates.type = editType;
      if (editStatus !== editingUser.status) updates.status = editStatus;
      if (editGroup !== editingUser.grupo) updates.grupo = editGroup;
      if (editRequire2FA !== (editingUser.require2FA || false)) updates.require2FA = editRequire2FA;

      // Solo incluir password si se escribió algo
      if (editPassword.trim() !== '') {
        // Política de contraseñas (norma FEMSA). El mínimo depende del tipo de
        // cuenta que quedará tras guardar, no del que tenía antes.
        // Misma regla que pinta PasswordField, incluida la confirmación.
        const chequeo = passwordFieldsOk(editPassword, editPasswordConfirm, editType, { optional: true });
        if (!chequeo.ok) {
          showToast.warning(
            chequeo.motivo === 'La contraseña no cumple la política'
              ? passwordPolicyHint(editType)
              : chequeo.motivo
          );
          return;
        }
        updates.password = editPassword;
      }

      // ✅ NUEVA LÓGICA:

      // Si no hay cambios, cerrar modal sin hacer nada
      if (Object.keys(updates).length === 0) {
        closeEditModal();
        showToast.info("No se realizaron cambios");
        return;
      }


      await updateUserAPI(editingUser.id, updates);
      await chkData({ silent: true });
      closeEditModal();

      // Notificar a otros módulos (p.ej. ScormAssign) que cambiaron los usuarios/grupos
      const prevGroup = editingUser && editingUser.grupo != null ? String(editingUser.grupo) : '';
      const nextGroup = updates.grupo != null ? String(updates.grupo) : prevGroup;
      if (markSelfRef.current) markSelfRef.current();
      notifyUsersChanged({
        action: 'user-updated',
        userId: editingUser.id,
        groupChanged: prevGroup !== nextGroup,
        prevGroup,
        nextGroup,
        updates
      });

      showToast.success("Usuario actualizado correctamente");

    } catch (error) {
      console.error('Error actualizando usuario:', error);
      showToast.error("No se pudo actualizar el usuario");
    }
  };

  //USUARIO NUEVO
  // Estados para crear nuevo usuario
  const [showNewUserModal, setShowNewUserModal] = useState(false);
  const [newUsername, setNewUsername] = useState('');
  const [newNombre, setNewNombre] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [newType, setNewType] = useState('user');
  const [newStatus, setNewStatus] = useState(false);
  const [newGroup, setNewGroup] = useState('');

  // Abrir popup de nuevo usuario
  const openNewUserModal = () => {
    setNewUsername('');
    setNewNombre('');
    setNewPassword('');
    setNewPasswordConfirm('');
    setNewType('user');
    setNewStatus(false);
    setNewGroup('');
    setShowNewUserModal(true);
  };

  // Cerrar popup de nuevo usuario
  const closeNewUserModal = () => {
    setShowNewUserModal(false);
    setNewUsername('');
    setNewNombre('');
    setNewPassword('');
    setNewPasswordConfirm('');
    setNewType('user');
    setNewGroup('');
    setNewStatus(false);
  };

  // Crear nuevo usuario
  const createNewUser = async () => {
    // Validar campos requeridos
    if (!newUsername.trim() || !newPassword.trim() || !newNombre.trim()) {
      /* Swal.fire({
        title: "Campos requeridos",
        text: "Por favor completa todos los campos obligatorios",
        icon: "warning"
      }); */
      showToast.warning("Por favor completa todos los campos obligatorios");
      return;
    }

    // ✨ NUEVA VALIDACIÓN: Longitud mínima
    if (newUsername.length < 3) {
      showToast.warning("El username debe tener al menos 3 caracteres");
      return;
    }

    // Misma regla que usa PasswordField para pintar el estado, así el botón y
    // los avisos del formulario no pueden discrepar.
    const chequeo = passwordFieldsOk(newPassword, newPasswordConfirm, newType);
    if (!chequeo.ok) {
      showToast.warning(
        chequeo.motivo === 'La contraseña no cumple la política'
          ? passwordPolicyHint(newType)
          : chequeo.motivo
      );
      return;
    }



    try {

      const notifyUsersChanged = (detail) => {
        try {
          if (typeof window.CustomEvent === 'function') {
            window.dispatchEvent(new CustomEvent('users:changed', { detail }));
          } else {
            window.dispatchEvent(new Event('users:changed'));
          }
        } catch (e) {}
      };

      await createUserAPI({
        username: newUsername,
        password: newPassword,
        nombre: newNombre,
        grupo: newGroup,
        type: newType,
        status: newStatus,
      });

      // Notificar a otros módulos (p.ej. ScormAssign) que cambiaron los usuarios/grupos
      notifyUsersChanged({
        action: 'user-created',
        group: newGroup
      });

      await chkData();
      closeNewUserModal();

      showToast.success("Usuario creado correctamente");

    } catch (error) {
      console.error('Error creando usuario:', error);
      const isLimit = error.message && error.message.toLowerCase().includes('límite');
      if (isLimit) {
        Swal.fire({ title: 'Límite alcanzado', text: error.message, icon: 'warning' });
      } else {
        showToast.error(error.message.includes('Usuario ya existe')
          ? "El username ya existe, elige otro"
          : "No se pudo crear el usuario");
      }
    }
  };

  useEffect(() => {
    if (showEditModal || showNewUserModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showEditModal, showNewUserModal]);


  // Función para ordenar por cualquier campo
  const sortByField = (field) => {
    let newOrder = 'asc';

    // Si ya está ordenado por este campo, cambiar dirección
    if (sortField === field && sortOrder === 'asc') {
      newOrder = 'desc';
    }

    setSortField(field);
    setSortOrder(newOrder);
  };

  // Componente para cabeceras con ordenamiento
  const SortableHeader = ({ field, children, className = "" }) => (
    <th
      scope="col"
      className={`${className} sortable-header`}
      onClick={() => sortByField(field)}
      style={{ cursor: 'pointer', userSelect: 'none' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>{children}</span>
        <span style={{ marginLeft: '5px', fontSize: '12px' }}>
          {sortField === field ? (
            sortOrder === 'asc' ? (
              <FontAwesomeIcon icon={faSortUp} />
            ) : (
              <FontAwesomeIcon icon={faSortDown} />
            )
          ) : (
            <FontAwesomeIcon icon={faSort} style={{ opacity: 0.3 }} />
          )}
        </span>
      </div>
    </th>
  );

  // Agregar después de los otros estados
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [unassignLoading, setUnassignLoading] = useState({});

  // Columnas configurables (persistidas)
  const USER_TABLE_COLUMNS = useMemo(() => ([
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'username', label: 'Usuario', sortable: true },
    { key: 'grupo', label: 'Grupo', sortable: true },
    { key: 'type', label: 'Tipo', sortable: true },
    { key: 'require2FA', label: '2FA', sortable: true },
    { key: 'statusPercent', label: 'Avance global', sortable: true },
    { key: 'createdAt', label: 'Fecha de alta', sortable: true },
    { key: 'updatedAt', label: 'Última actualización', sortable: true },
    { key: 'scormAssigned', label: 'SCORM asignados', sortable: false }
  ]), []);
  const DEFAULT_COL_ORDER = useMemo(() => USER_TABLE_COLUMNS.map(c => c.key), [USER_TABLE_COLUMNS]);
  const DEFAULT_COL_VISIBLE = useMemo(() => {
    const vis = {};
    USER_TABLE_COLUMNS.forEach(c => { vis[c.key] = true; });
    return vis;
  }, [USER_TABLE_COLUMNS]);

  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [userColOrder, setUserColOrder] = useState(DEFAULT_COL_ORDER);
  const [userColVisible, setUserColVisible] = useState(DEFAULT_COL_VISIBLE);

  useEffect(() => {
    try {
      const raw = localStorage.getItem('admin_user_table_cols_v1');
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && Array.isArray(parsed.order) && typeof parsed.visible === 'object') {
        const safeOrder = parsed.order.filter(k => DEFAULT_COL_ORDER.includes(k));
        const mergedOrder = [...safeOrder, ...DEFAULT_COL_ORDER.filter(k => !safeOrder.includes(k))];
        const vis = { ...DEFAULT_COL_VISIBLE };
        for (const k of Object.keys(parsed.visible || {})) {
          if (k in vis) vis[k] = Boolean(parsed.visible[k]);
        }
        setUserColOrder(mergedOrder);
        setUserColVisible(vis);
      }
    } catch (e) {
      // ignore
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('admin_user_table_cols_v1', JSON.stringify({ order: userColOrder, visible: userColVisible }));
    } catch (e) {
      // ignore
    }
  }, [userColOrder, userColVisible]);

  const moveColumn = (key, dir) => {
    setUserColOrder((prev) => {
      const idx = prev.indexOf(key);
      if (idx === -1) return prev;
      const next = [...prev];
      const swapWith = dir === 'up' ? idx - 1 : idx + 1;
      if (swapWith < 0 || swapWith >= next.length) return prev;
      [next[idx], next[swapWith]] = [next[swapWith], next[idx]];
      return next;
    });
  };

  const visibleColumnKeys = useMemo(() => userColOrder.filter(k => userColVisible[k]), [userColOrder, userColVisible]);
  const columnByKey = useMemo(() => {
    const m = {};
    USER_TABLE_COLUMNS.forEach(c => { m[c.key] = c; });
    return m;
  }, [USER_TABLE_COLUMNS]);

  // Edición inline
  const [inlineEdit, setInlineEdit] = useState(null); // { userId, field }
  const [inlineValue, setInlineValue] = useState('');
  const [inlineSaving, setInlineSaving] = useState(false);

  const startInlineEdit = (user, field) => {
    if (!user || !user.id) return;
    setInlineEdit({ userId: user.id, field });
    setInlineValue((user[field] || '').toString());
  };

  const cancelInlineEdit = () => {
    setInlineEdit(null);
    setInlineValue('');
    setInlineSaving(false);
  };

  const saveInlineEdit = async () => {
    if (!inlineEdit) return;
    const { userId, field } = inlineEdit;
    const value = (inlineValue || '').toString().trim();
    if (!value) return showToast.error('No puede ir vacío');

    setInlineSaving(true);
    const loading = showToast.loading('Guardando...');
    try {
      await updateUserAPI(userId, { [field]: value });
      setTodos(prev => prev.map(u => (u.id === userId ? { ...u, [field]: value } : u)));
      setOriginalTodos(prev => prev.map(u => (u.id === userId ? { ...u, [field]: value } : u)));

      if (field === 'grupo') {
        try {
          window.dispatchEvent(new CustomEvent('users:changed', { detail: { action: 'inline-edit', userId, field, value } }));
        } catch (e) {
          try { window.dispatchEvent(new Event('users:changed')); } catch (e2) {}
        }
      }
      showToast.success('Actualizado');
      cancelInlineEdit();
    } catch (e) {
      showToast.error('No se pudo actualizar');
    } finally {
      toast.dismiss(loading);
      setInlineSaving(false);
    }
  };

  const runWithLimit = async (items, limit, worker) => {
    const queue = [...items];
    const runners = Array.from({ length: Math.min(limit, queue.length) }).map(async () => {
      while (queue.length) {
        const item = queue.shift();
        await worker(item);
      }
    });
    await Promise.all(runners);
  };

  const bulkChangeGroup = async () => {
    if (selectedUsers.length === 0) return showToast.warning('Selecciona usuarios');
    const groupOptions = {};
    (adminGroupsList || []).forEach(g => { groupOptions[g.name] = g.name; });
    const r = await Swal.fire({
      title: 'Cambiar grupo',
      input: 'select',
      inputOptions: groupOptions,
      inputLabel: `Nuevo grupo para ${selectedUsers.length} usuarios`,
      inputPlaceholder: 'Seleccionar grupo',
      showCancelButton: true,
      confirmButtonText: 'Aplicar',
      cancelButtonText: 'Cancelar'
    });
    if (!r.isConfirmed) return;
    const newGroup = (r.value || '').toString().trim();
    if (!newGroup) return showToast.error('Selecciona un grupo');

    const loading = showToast.loading('Actualizando grupo...');
    try {
      await runWithLimit(selectedUsers, 8, async (id) => updateUserAPI(id, { grupo: newGroup }));
      setTodos(prev => prev.map(u => (selectedUsers.includes(u.id) ? { ...u, grupo: newGroup } : u)));
      setOriginalTodos(prev => prev.map(u => (selectedUsers.includes(u.id) ? { ...u, grupo: newGroup } : u)));
      try {
        window.dispatchEvent(new CustomEvent('users:changed', { detail: { reason: 'bulk-group-change', group: newGroup, count: selectedUsers.length } }));
      } catch (e) {
        try { window.dispatchEvent(new Event('users:changed')); } catch (e2) {}
      }
      showToast.success('Grupo actualizado');
    } catch (e) {
      showToast.error('Error actualizando grupo');
    } finally {
      toast.dismiss(loading);
    }
  };

  const bulkToggle2FA = async (enabled) => {
    if (selectedUsers.length === 0) return showToast.warning('Selecciona usuarios');
    const r = await Swal.fire({
      title: `${enabled ? 'Activar' : 'Desactivar'} 2FA`,
      text: `¿${enabled ? 'Activar' : 'Desactivar'} verificación por correo para ${selectedUsers.length} usuario(s)?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, aplicar',
      cancelButtonText: 'Cancelar'
    });
    if (!r.isConfirmed) return;

    const loading = showToast.loading(`${enabled ? 'Activando' : 'Desactivando'} 2FA...`);
    try {
      await runWithLimit(selectedUsers, 8, async (id) => updateUserAPI(id, { require2FA: enabled }));
      setTodos(prev => prev.map(u => (selectedUsers.includes(u.id) ? { ...u, require2FA: enabled } : u)));
      setOriginalTodos(prev => prev.map(u => (selectedUsers.includes(u.id) ? { ...u, require2FA: enabled } : u)));
      showToast.success(`2FA ${enabled ? 'activado' : 'desactivado'} para ${selectedUsers.length} usuario(s)`);
    } catch (e) {
      showToast.error('Error actualizando 2FA');
    } finally {
      toast.dismiss(loading);
    }
  };

  // Agregar después de handleGlobalSearch
  const handleSelectUser = (userId, isSelected) => {
    if (isSelected) {
      setSelectedUsers([...selectedUsers, userId]);
    } else {
      setSelectedUsers(selectedUsers.filter(id => id !== userId));
    }
  };

  const handleSelectAll = (isSelected) => {
    setSelectAll(isSelected);
    if (isSelected) {
      setSelectedUsers(itemsEstaPagina.map(user => user.id));
    } else {
      setSelectedUsers([]);
    }
  };

  const clearSelection = () => {
    setSelectedUsers([]);
    setSelectAll(false);
  };

  const selectAllFiltered = async () => {
    const ids = (sortedTodos || []).map(u => u.id).filter(Boolean);
    if (!ids.length) return showToast.warning('No hay usuarios para seleccionar');

    if (ids.length > 1000) {
      const confirm = await Swal.fire({
        title: 'Seleccionar muchos usuarios',
        text: `Vas a seleccionar ${ids.length} usuarios filtrados. ¿Continuar?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, seleccionar',
        cancelButtonText: 'Cancelar'
      });
      if (!confirm.isConfirmed) return;
    }

    setSelectedUsers(ids);
    setSelectAll(false);
    showToast.success(`Seleccionados: ${ids.length}`);
  };

  const clearUserTableFilters = () => {
    setGlobalSearch('');
    setFilterType('all');
    setFilterStatus('all');
    setFilterHasScorm('all');
    setFilterGroup('all');
    setFilterProgress('all');
    setFilterCreatedFrom('');
    setFilterCreatedTo('');
    setSortField(null);
    setSortOrder('asc');
    setPaginaActual(1);
  };

  useEffect(() => {
    // Si cambian filtros/orden/página, evitamos que el checkbox quede inconsistente
    setSelectAll(false);
  }, [paginaActual, globalSearch, filterType, filterStatus, filterHasScorm, filterGroup, filterProgress, filterCreatedFrom, filterCreatedTo, sortField, sortOrder]);

  // También actualizar deleteSelectedUsers:
  const deleteSelectedUsers = async () => {
    if (selectedUsers.length === 0) {
      /* Swal.fire({
        title: "Sin selección",
        text: "Selecciona al menos un usuario para eliminar",
        icon: "warning"
      }); */
      showToast.warning("Selecciona al menos un usuario para eliminar");
      return;
    }

    // Obtener detalles de usuarios seleccionados
    const selectedUsersData = todos.filter(user => selectedUsers.includes(user.id));
    const usersList = selectedUsersData.map(user =>
      `• <i class="fas fa-user"></i> ${user.username} (${user.nombre}) - <i class="fas fa-building"></i> ${user.grupo}`
    ).join('<br>');

    Swal.fire({
      title: `<i class="fas fa-trash"></i> ¿Eliminar ${selectedUsers.length} usuarios?`,
      html: `
      <div style="text-align: left; max-height: 200px; overflow-y: auto; padding: 10px; background: #f8f9fa; border-radius: 8px; margin: 10px 0;">
        ${usersList}
      </div>
      <p style="color: #dc3545; font-weight: bold;"><i class="fas fa-exclamation-triangle"></i> Esta acción no se puede deshacer</p>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      confirmButtonText: `<i class="fas fa-trash"></i> Sí, eliminar ${selectedUsers.length} usuarios`,
      cancelButtonText: '<i class="fas fa-times"></i> Cancelar',
      width: '600px'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const loading = showToast.loading('Eliminando usuarios...');
        try {
          const idsToDelete = [...selectedUsers];
          await runWithLimit(idsToDelete, 8, async (userId) => deleteUserAPI(userId));

          setTodos(prev => prev.filter(user => !idsToDelete.includes(user.id)));
          setOriginalTodos(prev => prev.filter(user => !idsToDelete.includes(user.id)));
          setSelectedUsers([]);
          setSelectAll(false);

          showToast.success(`${idsToDelete.length} usuarios eliminados correctamente`);
          try {
            window.dispatchEvent(new CustomEvent('users:changed', { detail: { reason: 'bulk-delete', count: idsToDelete.length } }));
          } catch (e) {
            try { window.dispatchEvent(new Event('users:changed')); } catch (e2) {}
          }
        } catch (error) {
          showToast.error("No se pudo eliminar el usuario");
        } finally {
          try { toast.dismiss(loading); } catch (e) {}
        }
      }
    });
  };


  // KPI calculations
  const kpiTotal = (todos || []).length;
  // Mismo criterio que la columna "Avance global": si ya tenemos el progreso
  // por curso, ese manda sobre el statusPercent guardado en el usuario.
  const kpiCompleted = (todos || []).filter(u => {
    const userId = u && u.id ? String(u.id) : null;
    const summaries = userId ? (scormSummariesByUser && scormSummariesByUser[userId]) : null;
    const { total, percent } = getUserProgress(u, summaries);
    if (total > 0) return percent === 100;
    return u.status === true || clampPercent(u.statusPercent) === 100;
  }).length;
  const kpiInProgress = (todos || []).filter(u => {
    const userId = u && u.id ? String(u.id) : null;
    const summaries = userId ? (scormSummariesByUser && scormSummariesByUser[userId]) : null;
    const { total, percent, hasActivity } = getUserProgress(u, summaries);
    if (total > 0) return percent != null && percent < 100 && (percent > 0 || hasActivity);
    const p = clampPercent(u.statusPercent);
    return p != null && p > 0 && p < 100;
  }).length;
  const kpiCourses = (availableScorms || []).length;

  const versionTooltip = [
    `Front: v${GConText.version}`,
    serverVersion ? `Backend: v${serverVersion}` : 'Backend: sin respuesta',
    serverInstance ? `Instancia: ${serverInstance}` : null
  ].filter(Boolean).join('\n');

  return (
    <>
      {showEditModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal admin-modal--lg">
            <div className="admin-modal__header">
              <h4 className="admin-modal__title">
                <FontAwesomeIcon icon={faEdit} /> Editar: <strong>{editingUser?.username}</strong>
              </h4>
              <button className="admin-modal__close" onClick={closeEditModal}>✕</button>
            </div>

            <div className="admin-modal__body">
                <div className="admin-form-row">
                  <div className="admin-form-group">
                    <label className="admin-form-label">Username</label>
                    <input type="text" className="admin-form-input" value={editUsername} onChange={(e) => setEditUsername(e.target.value)} />
                  </div>
                  <div className="admin-form-group">
                    <label className="admin-form-label">Nombre</label>
                    <input type="text" className="admin-form-input" value={editNombre} onChange={(e) => setEditNombre(e.target.value)} />
                  </div>
                </div>

                <PasswordField
                  label="Nueva contraseña"
                  accountType={editType}
                  optional
                  value={editPassword}
                  onChange={setEditPassword}
                  confirm={editPasswordConfirm}
                  onConfirmChange={setEditPasswordConfirm}
                />

                <div className="admin-form-row">
                  <div className="admin-form-group">
                    <label className="admin-form-label">Tipo</label>
                    <select className="admin-form-input" value={editType} onChange={(e) => setEditType(e.target.value)}>
                      <option value="user">User</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                  <div className="admin-form-group">
                    <label className="admin-form-label">Grupo</label>
                    <select className="admin-form-input" value={editGroup} onChange={(e) => setEditGroup(e.target.value)}>
                      <option value="">— Sin grupo —</option>
                      {adminGroupsList.map(g => <option key={g.name} value={g.name}>{g.name}</option>)}
                    </select>
                  </div>
                </div>

                <div className="admin-form-group">
                  <label className="admin-form-label" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    2FA por correo:
                    <input type="checkbox" checked={editRequire2FA} onChange={(e) => setEditRequire2FA(e.target.checked)} style={{ width: 18, height: 18, cursor: 'pointer' }} />
                    <span style={{ fontSize: 13, color: editRequire2FA ? '#4caf50' : '#94a3b8', fontWeight: 'normal' }}>
                      {editRequire2FA ? 'Activo' : 'Inactivo'}
                    </span>
                  </label>
                </div>
            </div>

            <div className="admin-modal__footer">
              <button className="admin-btn admin-btn--secondary" onClick={closeEditModal}>
                <FontAwesomeIcon icon={faCancel} /> Cancelar
              </button>
              <button className="admin-btn admin-btn--primary" onClick={saveUserChanges}>
                <FontAwesomeIcon icon={faSave} /> Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {scormManageUser && (
        <div className="admin-scorm-modal-overlay" role="dialog" aria-modal="true">
          <div className="admin-scorm-modal">
            <div className="admin-scorm-modal__header">
              <div>
                <div style={{ fontSize: 16, fontWeight: 700 }}>Cursos asignados</div>
                <div className="admin-scorm-modal__sub">
                  {(scormManageUser.nombre || scormManageUser.username || scormManageUser.id)}
                  {' · '}
                  {normalizeAssignedScorms(scormManageUser.scormAssigned).length} curso{normalizeAssignedScorms(scormManageUser.scormAssigned).length !== 1 ? 's' : ''}
                </div>
              </div>
              <button type="button" className="btn_ch bg-rojo c-blanco" onClick={closeManageScorm}>✕</button>
            </div>

            <div className="admin-scorm-modal__assign">
              <div className="scorm-sort-toggle">
                <button type="button" className={`scorm-sort-btn ${scormSortAdmin === 'alpha' ? 'scorm-sort-btn--active' : ''}`} onClick={() => setScormSortAdmin('alpha')}>A-Z</button>
                <button type="button" className={`scorm-sort-btn ${scormSortAdmin === 'recent' ? 'scorm-sort-btn--active' : ''}`} onClick={() => setScormSortAdmin('recent')}>Recientes</button>
              </div>
              <select
                className="admin-scorm-modal__select"
                value={selectedScormForManageUser}
                onChange={(e) => setSelectedScormForManageUser(e.target.value)}
              >
                <option value="">+ Asignar curso...</option>
                {sortScorms(availableScorms, scormSortAdmin).map((s) => {
                  const id = s.id || s._id;
                  if (!id) return null;
                  return <option key={id} value={id}>{scormOptionLabel(s)}</option>;
                })}
              </select>
              <button
                type="button"
                className="btn_ch bg-verde c-blanco"
                disabled={assignManageLoading || !selectedScormForManageUser}
                onClick={assignSelectedScormToManageUser}
              >
                {assignManageLoading ? '...' : 'Asignar'}
              </button>
            </div>

            <div className="admin-scorm-modal__list">
              {normalizeAssignedScorms(scormManageUser.scormAssigned).length > 5 && (
                <div className="admin-scorm-modal__search">
                  <input
                    type="text"
                    className="admin-scorm-modal__search-input"
                    placeholder="🔍 Buscar curso..."
                    value={scormModalSearch}
                    onChange={(e) => setScormModalSearch(e.target.value)}
                  />
                  {scormModalSearch && (
                    <button className="admin-scorm-modal__search-clear" onClick={() => setScormModalSearch('')}>✕</button>
                  )}
                </div>
              )}
              {scormSummariesLoading[scormManageUser.id] && (
                <div className="text-muted" style={{ padding: '12px 20px', fontSize: 13 }}>Cargando estado...</div>
              )}
              {normalizeAssignedScorms(scormManageUser.scormAssigned).length === 0 && (
                <div className="admin-scorm-modal__empty">
                  <div style={{ fontSize: 32, marginBottom: 8 }}>📚</div>
                  Sin cursos asignados
                </div>
              )}

              {normalizeAssignedScorms(scormManageUser.scormAssigned).length > 0 && (
                <table className="admin-scorm-table">
                  <thead>
                    <tr>
                      <th className="admin-scorm-table__th">Curso</th>
                      <th className="admin-scorm-table__th admin-scorm-table__th--center" style={{ width: 130 }}>Estado</th>
                      <th className="admin-scorm-table__th admin-scorm-table__th--center" style={{ width: 70 }}>Score</th>
                      <th className="admin-scorm-table__th admin-scorm-table__th--center" style={{ width: 120 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {normalizeAssignedScorms(scormManageUser.scormAssigned)
                      .filter(s => !scormModalSearch || (s.title || '').toLowerCase().includes(scormModalSearch.toLowerCase()))
                      .map((s) => {
                      const summaries = scormSummariesByUser[scormManageUser.id] || null;
                      const sum = summaries ? (summaries[s.id] || null) : null;
                      const statusRaw = sum ? (sum.status || '').toString().toLowerCase() : '';
                      const score = sum && sum.score != null ? Math.round(sum.score) : null;
                      const done = statusRaw === 'completed' || statusRaw === 'passed';
                      return (
                        <tr key={s.id} className={`admin-scorm-table__row ${done ? 'admin-scorm-table__row--done' : ''}`}>
                          <td className="admin-scorm-table__td">
                            <div className="admin-scorm-table__name">{s.title}</div>
                          </td>
                          <td className="admin-scorm-table__td admin-scorm-table__td--center">
                            {done ? (
                              <span className="admin-scorm-tag admin-scorm-tag--done">Completado</span>
                            ) : statusRaw === 'failed' ? (
                              <span className="admin-scorm-tag admin-scorm-tag--failed">Reprobado</span>
                            ) : statusRaw ? (
                              <span className="admin-scorm-tag admin-scorm-tag--progress">En proceso</span>
                            ) : (
                              <span className="admin-scorm-tag">No iniciado</span>
                            )}
                          </td>
                          <td className="admin-scorm-table__td admin-scorm-table__td--center">
                            {score != null ? <strong>{score}</strong> : <span style={{ color: '#cbd5e1' }}>—</span>}
                          </td>
                          <td className="admin-scorm-table__td admin-scorm-table__td--center">
                            <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                              {/* <button type="button" className="admin-scorm-table__btn" onClick={() => showScormProgressForUser(scormManageUser.id, s.id, s.title)} title="Ver detalle">Detalle</button> */}
                              <button
                                type="button"
                                className="admin-scorm-table__btn admin-scorm-table__btn--danger"
                                disabled={!!unassignLoading[`${scormManageUser.id}_${s.id}`]}
                                title="Quitar asignación"
                                onClick={async () => {
                        const key = `${scormManageUser.id}_${s.id}`;
                        const confirm = await Swal.fire({ title: 'Desasignar SCORM?', text: `Eliminar asignación ${s.title} para este usuario?`, icon: 'warning', showCancelButton: true, confirmButtonText: 'Sí, desasignar' });
                        if (!confirm.isConfirmed) return;
                        let loadingToast;
                        try {
                          setUnassignLoading(prev => ({ ...prev, [key]: true }));
                          const token = sessionStorage.getItem('accessToken');
                          loadingToast = showToast.loading('Desasignando...');
                          const res = await fetch(`${process.env.REACT_APP_API_BASE || ''}/admin/scorm/unassign`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                            body: JSON.stringify({ userId: scormManageUser.id, scormId: s.id })
                          });
                          if (!res.ok) {
                            const errBody = await res.json().catch(() => ({}));
                            throw new Error(errBody.error || 'Error desasignando');
                          }
                          showToast.success('Asignación eliminada');

                          // ✅ Actualizar modal en caliente
                          setScormManageUser((prev) => {
                            if (!prev) return prev;
                            const nextAssigned = Array.isArray(prev.scormAssigned)
                              ? prev.scormAssigned.filter((item) => {
                                if (typeof item === 'string') return item !== s.id;
                                if (!item || typeof item !== 'object') return true;
                                const id = item.id || item.scormId || item._id;
                                return id !== s.id;
                              })
                              : [];
                            return { ...prev, scormAssigned: nextAssigned };
                          });

                          setScormSummariesByUser((prev) => {
                            const userId = scormManageUser.id;
                            if (!userId || !prev || !prev[userId]) return prev;
                            const next = { ...prev };
                            const summaries = { ...next[userId] };
                            delete summaries[s.id];
                            next[userId] = summaries;
                            return next;
                          });

                          await chkData();
                        } catch (err) {
                          showToast.error(err.message || 'Error');
                        } finally {
                          try { if (loadingToast) toast.dismiss(loadingToast); } catch (e) {}
                          setUnassignLoading(prev => { const copy = { ...prev }; delete copy[key]; return copy; });
                        }
                      }}
                    >
                      {unassignLoading[`${scormManageUser.id}_${s.id}`] ? '...' : 'Quitar'}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
      {previewScorm && (
        <div className="pop_up" style={{ zIndex: 1200 }}>
          <div className="modal" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className='modal-content' style={{
              width: '90vw',
              height: '80vh',
              borderRadius: '8px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
              border: 'none',
              background: '#fff',
              overflow: 'hidden'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', borderBottom: '1px solid #eee' }}>
                <strong>Previsualización SCORM</strong>
                <div>
                  <button className='btn_ch btn-sm' onClick={() => { navigator.clipboard.writeText(previewScorm); showToast.success('ID copiado'); }} style={{ marginRight: 8 }}>Copiar ID</button>
                  <button className='btn_ch btn-danger btn-sm' onClick={() => setPreviewScorm(null)}>Cerrar</button>
                </div>
              </div>
              <iframe
                title="SCORM Preview"
                src={`${process.env.REACT_APP_API_BASE || ''}/scorm/launch/${previewScorm}`}
                style={{ width: '100%', height: 'calc(100% - 44px)', border: 'none' }}
              />
            </div>
          </div>
        </div>
      )}

      {showNewUserModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal admin-modal--lg">
            <div className="admin-modal__header">
              <h4 className="admin-modal__title"><FontAwesomeIcon icon={faPlus} /> Crear Nuevo Usuario</h4>
              <button className="admin-modal__close" onClick={closeNewUserModal}>✕</button>
            </div>
            <div className="admin-modal__body">
              <div className="admin-form-row">
                <div className="admin-form-group">
                  <label className="admin-form-label">Username <span style={{ color: '#dc2626' }}>*</span></label>
                  <input type="text" className="admin-form-input" value={newUsername} onChange={(e) => setNewUsername(e.target.value)} placeholder="Ingresa username" />
                </div>
                <div className="admin-form-group">
                  <label className="admin-form-label">Nombre <span style={{ color: '#dc2626' }}>*</span></label>
                  <input type="text" className="admin-form-input" value={newNombre} onChange={(e) => setNewNombre(e.target.value)} placeholder="Nombre completo" />
                </div>
              </div>
              <PasswordField
                label="Contraseña"
                accountType={newType}
                value={newPassword}
                onChange={setNewPassword}
                confirm={newPasswordConfirm}
                onConfirmChange={setNewPasswordConfirm}
              />
              <div className="admin-form-row">
                <div className="admin-form-group">
                  <label className="admin-form-label">Tipo</label>
                  <select className="admin-form-input" value={newType} onChange={(e) => setNewType(e.target.value)}>
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <div className="admin-form-group">
                  <label className="admin-form-label">Grupo</label>
                  <input type="hidden" />
                  <select className="admin-form-input" value={newGroup} onChange={(e) => setNewGroup(e.target.value)}>
                    <option value="">— Sin grupo —</option>
                    {adminGroupsList.map(g => <option key={g.name} value={g.name}>{g.name}</option>)}
                  </select>
                </div>
              </div>
            </div>
            <div className="admin-modal__footer">
              <button className="admin-btn admin-btn--secondary" onClick={closeNewUserModal}><FontAwesomeIcon icon={faCancel} /> Cancelar</button>
              <button className="admin-btn admin-btn--primary" onClick={createNewUser}><FontAwesomeIcon icon={faPlus} /> Crear Usuario</button>
            </div>
          </div>
        </div>
      )}

      {showBulkImportModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal admin-modal--xl" style={{ maxHeight: '90vh' }}>
            <div className="admin-modal__header">
              <h4 className="admin-modal__title"><FontAwesomeIcon icon={faUpload} /> Importación masiva de usuarios</h4>
              <button className="admin-modal__close" onClick={closeBulkImportModal}>✕</button>
            </div>

            <div className="admin-modal__body" style={{ overflow: 'auto' }}>
              {/* Reglas visibles antes de subir. La política de contraseñas es
                  el motivo de rechazo más común y antes solo se descubría
                  después, fila por fila. */}
              <div style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 16px', marginBottom: 16, fontSize: 13, lineHeight: 1.6 }}>
                <div><strong>Contraseña:</strong> {passwordPolicyHint('user')}</div>
                <div><strong>Usuario:</strong> es el correo. Sin espacios ni acentos.</div>
                <div><strong>Grupo:</strong> puede ser distinto en cada fila — un mismo archivo admite todos los grupos. Los que no existan se crean solos.</div>
                <div style={{ color: '#64748b' }}>Se leen todas las hojas del archivo que tengan las columnas <em>nombre</em> y <em>usuario</em>.</div>
              </div>

              {/* Dropzone + acciones */}
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-start', marginBottom: 20 }}>
                <div
                  className={`scorm-dropzone ${bulkFileName ? 'scorm-dropzone--has-file' : ''}`}
                  style={{ flex: '1 1 280px', maxWidth: 360 }}
                  onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('scorm-dropzone--active'); }}
                  onDragLeave={(e) => { e.currentTarget.classList.remove('scorm-dropzone--active'); }}
                  onDrop={(e) => { e.preventDefault(); e.currentTarget.classList.remove('scorm-dropzone--active'); const f = e.dataTransfer.files && e.dataTransfer.files[0]; if (f) onBulkFileSelected(f); }}
                  onClick={() => { const inp = document.getElementById('bulk-file-input'); if (inp) inp.click(); }}
                >
                  <input id="bulk-file-input" type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={(e) => onBulkFileSelected(e.target.files && e.target.files[0])} disabled={bulkUploading} />
                  {bulkFileName ? (
                    <div className="scorm-dropzone__file">📄 {bulkFileName}</div>
                  ) : (
                    <div className="scorm-dropzone__placeholder">
                      <span style={{ fontSize: 24 }}>📂</span>
                      <span>Arrastra un archivo Excel o haz clic</span>
                      <span style={{ fontSize: 11, color: '#94a3b8' }}>.xlsx, .xls</span>
                    </div>
                  )}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={downloadBulkTemplate} disabled={bulkUploading}><FontAwesomeIcon icon={faFileArrowDown} /> Descargar plantilla</button>
                  <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={validateBulkAgainstSystem} disabled={bulkUploading || bulkChecking || !bulkRows.length}><FontAwesomeIcon icon={faSync} /> {bulkChecking ? 'Validando...' : 'Validar contra sistema'}</button>
                  <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={downloadBulkReport} disabled={bulkUploading || !bulkRows.length}><FontAwesomeIcon icon={faFileExport} /> Descargar reporte</button>
                </div>
              </div>

              {/* Configuración */}
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
                <div className="admin-form-group" style={{ minWidth: 160 }}>
                  <label className="admin-form-label">Modo</label>
                  <select className="admin-form-input" value={bulkMode} onChange={(e) => { const m = e.target.value; setBulkMode(m); setBulkRows(prev => recomputeBulkRows(prev, m, bulkUpdatePassword)); }} disabled={bulkUploading || bulkChecking} style={{ maxWidth: 200 }}>
                    <option value="create">Crear (solo nuevos)</option>
                    <option value="update">Actualizar (solo existentes)</option>
                    <option value="upsert">Upsert (crear + actualizar)</option>
                  </select>
                </div>
                <div className="admin-form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer' }}>
                    <input type="checkbox" checked={bulkUpdatePassword} onChange={(e) => { const n = e.target.checked; setBulkUpdatePassword(n); setBulkRows(prev => recomputeBulkRows(prev, bulkMode, n)); }} disabled={bulkUploading || bulkChecking} />
                    Actualizar contraseña
                  </label>
                </div>
                <div style={{ marginLeft: 'auto', fontSize: 13, color: '#64748b' }}>
                  Total: <strong>{bulkRows.length}</strong> · Válidas: <strong>{bulkRows.filter(r => r.ok).length}</strong> · Inválidas: <strong>{bulkRows.filter(r => !r.ok).length}</strong> · Validación: <strong>{bulkChecked ? '✓' : 'pendiente'}</strong>
                </div>
              </div>

              {/* Tabla de previsualización */}
              {bulkRows.length > 0 && (
                <div style={{ maxHeight: 360, overflow: 'auto', border: '1px solid rgba(0,0,0,0.06)', borderRadius: 12 }}>
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Hoja</th>
                        <th>#</th>
                        <th>Nombre</th>
                        <th>Username</th>
                        <th>Grupo</th>
                        <th>Existe</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bulkRows.slice(0, 300).map((r, idx) => (
                        <tr key={`${r._sheet}-${r._row}-${idx}`}>
                          <td style={{ color: '#64748b', fontSize: 12 }}>{r._sheet || '—'}</td>
                          <td>{r._row}</td>
                          <td>{r.nombre}</td>
                          <td>{r.username}</td>
                          <td>{r.grupo}</td>
                          <td style={{ textAlign: 'center' }}>
                            {r.exists == null ? '—' : r.exists ? <span className="badge bg-warning text-dark">Sí</span> : <span className="badge bg-secondary">No</span>}
                          </td>
                          <td>
                            {r.ok ? <span className="badge bg-success">OK</span> : <span className="badge bg-danger" style={{ fontSize: 11 }}>No sube: {r.errors.join(', ')}</span>}
                          </td>
                        </tr>
                      ))}
                      {bulkRows.length > 300 && <tr><td colSpan={7} style={{ color: '#94a3b8' }}>Mostrando primeras 300 filas…</td></tr>}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Resultado */}
              {bulkResult && (
                <div style={{ marginTop: 16, padding: 16, background: '#f8fafc', borderRadius: 12, fontSize: 13 }}>
                  <strong>Resultado:</strong> Solicitados: {bulkResult.summary?.requested ?? '-'} · Creados: {bulkResult.summary?.created ?? '-'} · Actualizados: {bulkResult.summary?.updated ?? '-'} · Duplicados: {bulkResult.summary?.skipped ?? '-'} · Fallidos: {bulkResult.summary?.failed ?? '-'}
                </div>
              )}
            </div>

            <div className="admin-modal__footer">
              <button className="admin-btn admin-btn--secondary" onClick={closeBulkImportModal}><FontAwesomeIcon icon={faCancel} /> Cerrar</button>
              <button className="admin-btn admin-btn--primary" onClick={uploadBulkUsers} disabled={bulkUploading}><FontAwesomeIcon icon={faUpload} /> {bulkUploading ? 'Importando...' : 'Subir usuarios válidos'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ===== NUEVO LAYOUT ===== */}
      <div className="admin-layout">
        {/* Sidebar overlay (mobile) */}
        {sidebarOpen && <div className="admin-sidebar-overlay admin-sidebar-overlay--visible" onClick={() => setSidebarOpen(false)} />}

        {/* Sidebar */}
        <aside className={`admin-sidebar ${sidebarOpen ? 'admin-sidebar--open' : ''}`}>
          <div className="admin-sidebar__logo">
            <img src={imgFemsaOscuro} alt="FEMSA" style={{ filter: 'brightness(0) invert(1)' }} />
            <img src={imgMircVerde} alt="MIRC" style={{ height: 28 }} />
          </div>
          <nav className="admin-sidebar__nav">
            {[
              { key: 'users', icon: faUser, label: 'Usuarios' },
              { key: 'upload', icon: faUpload, label: 'Subir SCORM' },
              { key: 'assign', icon: faPlus, label: 'Asignar a Grupo' },
              { key: '2fa', icon: faShieldAlt, label: '2FA por Grupo' },
              { key: 'preview', icon: faLightbulb, label: 'Preview' },
            ].map(item => (
              <button
                key={item.key}
                className={`admin-sidebar__item ${activeSection === item.key ? 'admin-sidebar__item--active' : ''}`}
                onClick={() => { setActiveSection(item.key); setSidebarOpen(false); }}
              >
                <span className="admin-sidebar__item-icon"><FontAwesomeIcon icon={item.icon} /></span>
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
          <div className="admin-sidebar__footer">
            <button className="admin-sidebar__item" onClick={logout} style={{ color: '#ff6b6b' }}>
              <span className="admin-sidebar__item-icon"><FontAwesomeIcon icon={faPowerOff} /></span>
              <span>Cerrar sesión</span>
            </button>

            {/* Versión de la plataforma.
                Se muestran las dos partes por separado a propósito: ya pasó que
                el front quedara atrás del backend, y con un ASG de 2 a 6
                instancias y despliegues rolling un deploy puede quedar a medias.
                Si no coinciden, se avisa aquí mismo. */}
            <div className="admin-version" title={versionTooltip}>
              <span className="admin-version__label">Versión</span>
              <span className="admin-version__value">v{GConText.version}</span>
              {serverVersion && serverVersion !== GConText.version && (
                <span className="admin-version__warn" title={`El backend responde v${serverVersion} y el front es v${GConText.version}. Si acabas de desplegar, refresca en un minuto; si sigue distinto, quedó una instancia sin actualizar.`}>
                  backend v{serverVersion}
                </span>
              )}
            </div>
          </div>
        </aside>

        {/* Main */}
        <div className="admin-main">
          {/* Navbar */}
          <header className="admin-navbar">
            <div className="admin-navbar__left">
              <button className="admin-navbar__hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
              <div>
                <div className="admin-navbar__title">Panel de Administración</div>
                <div className="admin-navbar__subtitle">Última actualización: {new Date(lastRefresh).toLocaleString()}</div>
              </div>
            </div>
            <div className="admin-navbar__right">
              <button className="admin-navbar__btn" onClick={isLoading ? null : refreshData} disabled={isLoading}>
                {isLoading ? <><span className="spinner-border spinner-border-sm" role="status"></span> Actualizando...</> : <><FontAwesomeIcon icon={faSync} /> Actualizar</>}
              </button>
              {activeSection === 'users' && (
                <>
                  <button className="admin-navbar__btn" onClick={() => exportUsersToExcel('filtered')}><FontAwesomeIcon icon={faFileExport} /> Exportar filtrado</button>
                  <button className="admin-navbar__btn" onClick={() => exportUsersToExcel('all')}><FontAwesomeIcon icon={faFileExport} /> Exportar todo</button>
                  <button className="admin-navbar__btn" onClick={() => setShowBulkImportModal(true)}><FontAwesomeIcon icon={faUpload} /> Usuarios masivos</button>
                  <button className="admin-navbar__btn admin-navbar__btn--primary" onClick={openNewUserModal}><FontAwesomeIcon icon={faPlus} /> Usuario</button>
                </>
              )}
              {GConText.logs && (
                <button className="admin-navbar__btn" onClick={debugTokenInfo}><FontAwesomeIcon icon={faCog} /> Debug</button>
              )}
            </div>
          </header>

          {/* Content */}
          <main className="admin-content">
            {/* KPI Cards - solo en sección usuarios */}
            {activeSection === 'users' && (
              <div className="admin-kpis">
                <div className="admin-kpi-card">
                  <div className="admin-kpi-card__label">Total Usuarios</div>
                  <div className="admin-kpi-card__value">{kpiTotal}{platformLimits ? <span style={{fontSize:'0.5em',color:'#888'}}>/{platformLimits.maxUsers}</span> : ''}</div>
                </div>
                <div className="admin-kpi-card">
                  <div className="admin-kpi-card__label">Completados</div>
                  <div className="admin-kpi-card__value" style={{ color: '#4caf50' }}>{kpiCompleted}</div>
                </div>
                <div className="admin-kpi-card">
                  <div className="admin-kpi-card__label">En Progreso</div>
                  <div className="admin-kpi-card__value" style={{ color: '#ff7f36' }}>{kpiInProgress}</div>
                </div>
                <div className="admin-kpi-card">
                  <div className="admin-kpi-card__label">Cursos SCORM</div>
                  <div className="admin-kpi-card__value" style={{ color: '#E40046' }}>{kpiCourses}{platformLimits ? <span style={{fontSize:'0.5em',color:'#888'}}>/{platformLimits.maxCourses}</span> : ''}</div>
                </div>
              </div>
            )}

            {/* Sección SCORM (upload/assign/2fa/preview) */}
            {activeSection === 'upload' && (
              <div className="admin-panel"><div className="admin-panel__body"><ScormUpload /></div></div>
            )}
            {activeSection === 'assign' && (
              <div className="admin-panel"><div className="admin-panel__body"><ScormAssign onAssigned={chkData} /></div></div>
            )}
            {activeSection === '2fa' && (
              <div className="admin-panel"><div className="admin-panel__body"><ScormAssign onAssigned={chkData} show2FAOnly /></div></div>
            )}
            {activeSection === 'preview' && (
              <div className="admin-panel"><div className="admin-panel__body"><ScormPreview onOpenModal={setPreviewScorm} /></div></div>
            )}

            {/* Sección Usuarios */}
            {activeSection === 'users' && (
              <div className="admin-panel">
                {/* Filtros */}
                <div className="admin-filters">
                  <div className="admin-filters__group" style={{ flex: 1 }}>
                    <label className="admin-filters__label">Búsqueda</label>
                    <input className="admin-filters__input admin-filters__input--search" type="text" placeholder="Buscar en todos los campos..." value={globalSearch} onChange={handleGlobalSearch} />
                  </div>
                  <div className="admin-filters__group">
                    <label className="admin-filters__label">Tipo</label>
                    <select className="admin-filters__input" value={filterType} onChange={(e) => { setFilterType(e.target.value); setPaginaActual(1); }}>
                      <option value="all">Todos</option>
                      <option value="user">User</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                  <div className="admin-filters__group">
                    <label className="admin-filters__label">Avance</label>
                    <select className="admin-filters__input" value={filterProgress} onChange={(e) => { setFilterProgress(e.target.value); setPaginaActual(1); }}>
                      <option value="all">Todos</option>
                      <option value="no_scorm">Sin cursos</option>
                      <option value="no_iniciado">No iniciado</option>
                      <option value="en_proceso">En proceso</option>
                      <option value="completado">Completado</option>
                    </select>
                  </div>
                  <div className="admin-filters__group" style={{ minWidth: 160 }}>
                    <label className="admin-filters__label">Grupo</label>
                    <Select
                      instanceId="admin-group-filter"
                      value={selectedGroupOption}
                      options={groupSelectOptions}
                      onChange={(opt) => { setFilterGroup((opt && opt.value) ? opt.value : 'all'); setPaginaActual(1); }}
                      isSearchable
                      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                      styles={groupSelectStyles}
                      noOptionsMessage={() => 'Sin grupos'}
                    />
                  </div>
                  <div className="admin-filters__group">
                    <label className="admin-filters__label">SCORM</label>
                    <select className="admin-filters__input" value={filterHasScorm} onChange={(e) => { setFilterHasScorm(e.target.value); setPaginaActual(1); }}>
                      <option value="all">Todos</option>
                      <option value="yes">Con SCORM</option>
                      <option value="no">Sin SCORM</option>
                    </select>
                  </div>
                  <div className="admin-filters__group">
                    <label className="admin-filters__label">Desde</label>
                    <input className="admin-filters__input" type="date" value={filterCreatedFrom} onChange={(e) => { setFilterCreatedFrom(e.target.value); setPaginaActual(1); }} />
                  </div>
                  <div className="admin-filters__group">
                    <label className="admin-filters__label">Hasta</label>
                    <input className="admin-filters__input" type="date" value={filterCreatedTo} onChange={(e) => { setFilterCreatedTo(e.target.value); setPaginaActual(1); }} />
                  </div>
                  <div className="admin-filters__actions">
                    <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={() => setShowColumnConfig(true)} title="Configurar columnas"><FontAwesomeIcon icon={faCog} /> Columnas</button>
                    <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={clearUserTableFilters}><FontAwesomeIcon icon={faCancel} /> Limpiar</button>
                  </div>
                </div>

                {/* Paginación superior */}
                <div className="admin-pagination">
                  <div className="admin-pagination__info">
                    {registros} usuario{registros !== 1 ? 's' : ''} encontrado{registros !== 1 ? 's' : ''}
                  </div>
                  <div className="admin-pagination__controls">
                    <select className="admin-pagination__per-page" value={itemsPorPagina} onChange={(e) => { setPaginaActual(1); setItemsPorPagina(Number(e.target.value)); }}>
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                    <ResponsivePagination current={paginaActual} total={totalpaginas} onPageChange={setPaginaActual} />
                    <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={selectAllFiltered}><FontAwesomeIcon icon={faPlus} /> Seleccionar todos</button>
                    {selectedUsers.length > 0 && (
                      <button className="admin-btn admin-btn--sm admin-btn--ghost" onClick={clearSelection}><FontAwesomeIcon icon={faCancel} /> Limpiar selección</button>
                    )}
                  </div>
                </div>
                {/* Acciones masivas */}
                {selectedUsers.length > 0 && (
                  <div className="admin-bulk-bar">
                    <span className="admin-bulk-bar__count">{selectedUsers.length} seleccionado{selectedUsers.length !== 1 ? 's' : ''}</span>
                    <div className="admin-bulk-bar__actions">
                      <button className="admin-btn admin-btn--sm admin-btn--danger" onClick={deleteSelectedUsers}><FontAwesomeIcon icon={faTrash} /> Eliminar</button>
                      <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={bulkChangeGroup}><FontAwesomeIcon icon={faEdit} /> Cambiar grupo</button>
                      <button className="admin-btn admin-btn--sm admin-btn--success" onClick={() => bulkToggle2FA(true)}><FontAwesomeIcon icon={faLockOpen} /> Activar 2FA</button>
                      <button className="admin-btn admin-btn--sm admin-btn--secondary" onClick={() => bulkToggle2FA(false)}><FontAwesomeIcon icon={faLock} /> Desactivar 2FA</button>
                      <select className="admin-bulk-bar__select" value={selectedScormForBulk} onChange={(e) => setSelectedScormForBulk(e.target.value)}>
                        <option value="">-- Asignar SCORM --</option>
                        {sortScorms(availableScorms, scormSortAdmin).map((s) => {
                          const id = s.id || s._id;
                          return <option key={id} value={id}>{scormOptionLabel(s)}</option>;
                        })}
                      </select>
                      {selectedScormForBulk && (
                        <>
                          <button className="admin-btn admin-btn--sm admin-btn--success" onClick={async () => {
                            const token = sessionStorage.getItem('accessToken');
                            const loading = showToast.loading('Asignando...');
                            try {
                              const res = await fetch(`${process.env.REACT_APP_API_BASE || ''}/admin/scorm/assign-batch`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ userIds: selectedUsers, scormId: selectedScormForBulk }) });
                              if (!res.ok) throw new Error('Error');
                              const data = await res.json();
                              showToast.success(`Asignadas: ${data.succeeded}/${data.requested}`);
                              setSelectedScormForBulk('');
                              await chkData();
                            } catch (e) { showToast.error('Error asignando'); } finally { toast.dismiss(loading); }
                          }}>Asignar</button>
                          <button className="admin-btn admin-btn--sm admin-btn--danger" onClick={async () => {
                            const token = sessionStorage.getItem('accessToken');
                            const loading = showToast.loading('Desasignando...');
                            try {
                              const res = await fetch(`${process.env.REACT_APP_API_BASE || ''}/admin/scorm/unassign-batch`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ userIds: selectedUsers, scormId: selectedScormForBulk }) });
                              if (!res.ok) throw new Error('Error');
                              const data = await res.json();
                              showToast.success(`Desasignadas: ${data.succeeded}/${data.requested}`);
                              setSelectedScormForBulk('');
                              await chkData();
                            } catch (e) { showToast.error('Error desasignando'); } finally { toast.dismiss(loading); }
                          }}>Desasignar</button>
                        </>
                      )}
                    </div>
                  </div>
                )}

                {/* Tabla */}
                <div className="admin-panel__body admin-panel__body--flush">
                  <div className="admin-table-wrapper">
                    <table className="admin-table" ref={tableRef}>
                      <thead>
                        <tr>
                          <th style={{ width: 40 }}>
                            <input type="checkbox" checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} style={{ cursor: 'pointer' }} />
                          </th>
                          <th style={{ width: 40 }}>#</th>
                          {visibleColumnKeys.map((key) => {
                            const col = columnByKey[key];
                            if (!col) return null;
                            if (col.sortable) {
                              return (
                                <SortableHeader key={key} field={key}>{col.label}</SortableHeader>
                              );
                            }
                            return <th key={key}>{col.label}</th>;
                          })}
                          <th style={{ width: 80 }}>Editar</th>
                          <th style={{ width: 80 }}>Eliminar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemsEstaPagina.map((option, i) => (
                          <tr key={option.id || option.Ranking}>
                            <td data-label="Seleccionar">
                              <input type="checkbox" checked={selectedUsers.includes(option.id)} onChange={(e) => handleSelectUser(option.id, e.target.checked)} style={{ cursor: 'pointer' }} />
                            </td>
                            <td data-label="#">{primerItemIndex + i + 1}</td>
                            {visibleColumnKeys.map((key) => {
                              if (key === 'nombre') {
                                const isEditing = inlineEdit && inlineEdit.userId === option.id && inlineEdit.field === 'nombre';
                                return (
                                  <td key={key} data-label="Nombre" onDoubleClick={() => startInlineEdit(option, 'nombre')} title="Doble click para editar" style={{ cursor: 'text' }}>
                                    {isEditing ? (
                                      <input className="admin-filters__input" value={inlineValue} disabled={inlineSaving} autoFocus onChange={(e) => setInlineValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') saveInlineEdit(); if (e.key === 'Escape') cancelInlineEdit(); }} onBlur={() => saveInlineEdit()} style={{ padding: '4px 8px', fontSize: 13 }} />
                                    ) : option.nombre}
                                  </td>
                                );
                              }
                              if (key === 'username') return <td key={key} data-label="Usuario">{option.username}</td>;
                              if (key === 'grupo') {
                                const isEditing = inlineEdit && inlineEdit.userId === option.id && inlineEdit.field === 'grupo';
                                return (
                                  <td key={key} data-label="Grupo" onDoubleClick={() => startInlineEdit(option, 'grupo')} title="Doble click para editar" style={{ cursor: 'text' }}>
                                    {isEditing ? (
                                      <select className="admin-filters__input" value={inlineValue} disabled={inlineSaving} autoFocus onChange={(e) => { setInlineValue(e.target.value); }} onKeyDown={(e) => { if (e.key === 'Enter') saveInlineEdit(); if (e.key === 'Escape') cancelInlineEdit(); }} onBlur={() => saveInlineEdit()} style={{ padding: '4px 8px', fontSize: 13 }}>
                                        <option value="">— Sin grupo —</option>
                                        {adminGroupsList.map(g => <option key={g.name} value={g.name}>{g.name}</option>)}
                                      </select>
                                    ) : option.grupo}
                                  </td>
                                );
                              }
                              if (key === 'type') {
                                return (
                                  <td key={key} data-label="Tipo" style={{ textAlign: 'center' }}>
                                    {option.type === 'admin' ? (
                                      <span className="badge bg-warning text-dark" style={{ fontSize: 13, padding: '6px 14px', display: 'inline-block', width: 64 }}>Admin</span>
                                    ) : (
                                      <span className="badge bg-primary" style={{ fontSize: 13, padding: '6px 14px', display: 'inline-block', width: 64 }}>User</span>
                                    )}
                                  </td>
                                );
                              }
                              if (key === 'require2FA') {
                                return (
                                  <td key={key} data-label="2FA" style={{ textAlign: 'center' }}>
                                    <FontAwesomeIcon icon={faShieldAlt} style={{ color: option.require2FA ? '#4caf50' : '#ddd' }} title={option.require2FA ? '2FA activo' : '2FA inactivo'} />
                                  </td>
                                );
                              }
                              if (key === 'createdAt') return <td key={key} data-label="Alta">{formatearFechaSimple(option.createdAt)}</td>;
                              if (key === 'updatedAt') return <td key={key} data-label="Actualización">{formatearFechaSimple(option.updatedAt)}</td>;
                              if (key === 'statusPercent') {
                                const summaries = scormSummariesByUser[option.id] || null;
                                const isAutoLoading = Boolean(scormSummariesLoading && scormSummariesLoading[option.id]);
                                const { total, percent, completedCount, hasActivity } = getUserProgress(option, summaries);
                                if (total === 0) return <td key={key} data-label="Avance global" style={{ textAlign: 'center', color: '#94a3b8' }}>—</td>;
                                let statusLabel = isAutoLoading ? '...' : '—';
                                let badgeClass = 'bg-light text-dark';
                                if (percent != null) {
                                  if (percent >= 100) { statusLabel = `Completado ${total}/${total}`; badgeClass = 'badge-completado'; }
                                  else if (percent >= 1 || hasActivity) { statusLabel = `En proceso ${completedCount}/${total}`; badgeClass = 'badge-en-progreso'; }
                                  else { statusLabel = `No iniciado 0/${total}`; badgeClass = 'badge-no-iniciado'; }
                                }
                                return <td key={key} data-label="Avance global" style={{ textAlign: 'center' }}><span className={`badge ${badgeClass}`}>{statusLabel}</span></td>;
                              }
                              if (key === 'scormAssigned') {
                                const scorms = normalizeAssignedScorms(option.scormAssigned);
                                if (!scorms.length) {
                                  return (
                                    <td key={key} data-label="SCORM" style={{ textAlign: 'center' }}>
                                      <button type="button" className="admin-btn admin-btn--sm admin-btn--success" onClick={() => { setScormManageUser(option); setSelectedScormForManageUser(''); loadAvailableScorms(); }}>+ Asignar</button>
                                    </td>
                                  );
                                }
                                const total = scorms.length;
                                const summaries = scormSummariesByUser[option.id] || null;
                                const { completedCount } = getUserProgress(option, summaries);
                                return (
                                  <td key={key} data-label="SCORM" style={{ textAlign: 'center' }}>
                                    <button type="button" className="scorm-cell-btn" onClick={() => { setScormManageUser(option); ensureScormSummariesForUser(option.id); }} title={scorms.map(s => s.title).join(' | ')}>
                                      <span className="scorm-cell-btn__count">{total}</span>
                                      <span className="scorm-cell-btn__label">curso{total !== 1 ? 's' : ''}</span>
                                      {completedCount != null && <span className={`scorm-cell-btn__status ${completedCount === total ? 'scorm-cell-btn__status--done' : ''}`}>{completedCount}/{total}</span>}
                                    </button>
                                  </td>
                                );
                              }
                              return null;
                            })}
                            <td data-label="Editar" style={{ textAlign: 'center' }}>
                              <button className="admin-btn admin-btn--sm admin-btn--warning" onClick={() => openEditModal(option)}><FontAwesomeIcon icon={faEdit} /></button>
                            </td>
                            <td data-label="Eliminar" style={{ textAlign: 'center' }}>
                              <button className="admin-btn admin-btn--sm admin-btn--danger" onClick={() => submitDelete(option.id, option.username, option)}><FontAwesomeIcon icon={faTrash} /></button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* Column config modal */}
            {showColumnConfig && (
              <div className="admin-modal-overlay">
                <div className="admin-modal">
                  <div className="admin-modal__header">
                    <h4 className="admin-modal__title"><FontAwesomeIcon icon={faCog} /> Columnas</h4>
                    <button className="admin-modal__close" onClick={() => setShowColumnConfig(false)}>✕</button>
                  </div>
                  <div className="admin-modal__body">
                    <p className="admin-text-muted admin-text-sm">Marca para mostrar/ocultar y usa ↑/↓ para reordenar.</p>
                    {userColOrder.map((key) => (
                      <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
                          <input type="checkbox" checked={Boolean(userColVisible[key])} onChange={(e) => setUserColVisible((prev) => ({ ...prev, [key]: e.target.checked }))} />
                          <span style={{ fontWeight: 600, fontSize: 13 }}>{columnByKey[key]?.label || key}</span>
                        </label>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="admin-btn admin-btn--sm admin-btn--ghost" onClick={() => moveColumn(key, 'up')}>↑</button>
                          <button className="admin-btn admin-btn--sm admin-btn--ghost" onClick={() => moveColumn(key, 'down')}>↓</button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="admin-modal__footer">
                    <button className="admin-btn admin-btn--secondary" onClick={() => setShowColumnConfig(false)}>Cerrar</button>
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      </div>
    </>

  )
}

export default Admin
